// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/Montserrat-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `(decisionvue-mockups)
/*******************************************************************************
  For styles which apply to the Risk Dashboard.

  Classes prefixed with rd- are for components that are used in
  the risk dashboard only.

  Author: Beck Davies
  Date: March 12th, 2019

*******************************************************************************/

/* start mockup decisionvue.css (used for the login page) */

:root {
  /* Colours which apply to the risk levels */
  --level01: 95, 60%, 62%;
  --level02: 62, 85%, 70%;
  --level03: 42, 98%, 65%;
  --level04: 15, 84%, 59%;
  --level05: 1, 69%, 49%;

  /* Varying opacities */
  --opacity-standard: 0.8;
  --opacity-muted: 0.4;

  /* Brand colours */
  --wood-grey: #233845;
  --wood-green: rgba(136, 197, 64, 1);
  --wood-teal: rgba(45, 189, 182, 1);
  --wood-teal-light: rgba(45, 189, 182, 0.1);
  --wood-teal-dark: rgb(89, 137, 135);
  --wood-purple: rgba(136, 76, 145, 1);

  --grey1: #f3f3f3;
  --grey2: #ced4da;
  --grey3: #adbcbb;
  --grey4: #849faf;

  --red: #d04435;
  --light-red: #f9e8e6;

}

*,
*::before,
*::after {
  box-sizing: border-box
}

@font-face {
  font-family: 'Montserrat';
  src: local('Montserrat'), url(${___CSS_LOADER_URL_REPLACEMENT_0___})  format('truetype')
}

html {
  font-size: 14px
}

body {
  margin: 0;
  padding: 0;
  line-height: 1.6;
  font-size: 1rem;
  font-family: 'Montserrat', sans-serif;
  color: #233845;
  background-color: #fff
}

img {
  width: 100%;
}

label {
  font-weight: 700;
  color: var(--grey4)
}

a {
  color: var(--wood-teal)
}

.hc-content {
  display: flex;
  align-items: flex-start
}

.hc-content__menu {
  width: 250px;
  height: calc(100vh - 91px);
  overflow-y: auto;
  border-right: 1px solid var(--border-color)
}

.hc-content__config {
  flex-grow: 1;
  padding: 1.5rem;
}

.flex-row {
  display: flex;
  align-items: center;
}

.flex-row > * + * {
  margin-left: .5rem
}

.flex-row--align-top {
  align-items: flex-start;
}

.flex-row--align-end {
  align-items: flex-end;
}

.flex-row--space-between {
  justify-content: space-between;
}

.flex-row--margin + .flex-row--margin {
  margin-top: 1rem
}

.preferences-indent {
  margin-left: 20px;
}

.hc-location-details {
  margin-top: 1rem;
}

.hc-hazard {
  padding: 1rem;
  margin-bottom: 1rem;
  border-left: 0px solid var(--wood-teal);
  border-bottom: 2px solid var(--wood-teal)
}

/* .hc-hazard:nth-child(even) {

  background: var(--grey1);

} */

.hc-parameter {
  display: flex;
}

.hc-component {
  display: inline-block;
  align-items: center;
  margin-top: .25rem
}

.hc-component > * + * {
  margin-left: .5rem
}

.hazard-disabled {
  opacity: 0.6;
}

.hazard-enabled {
  opacity: 1;
}

.hc-actions {
  margin-left: auto;
  white-space: nowrap;
}

.hc-heading {
  display: flex;
  align-items: flex-end;
  border-bottom: 1px solid var(--grey3);
  font-size: 1.25rem;
  font-weight: bold;
  padding-bottom: 0.75rem;
  line-height: 1;
  color: var(--wood-teal);
  margin-bottom: .5rem;
}

.hc-heading__text {
  margin: 0;
}

.hc-heading--page {
  padding: 1rem 1rem 0.75rem 1rem;
  margin-bottom: 0;
}

.hc-block + .hc-block {
  margin-top: 3rem;
}

.region {
  background-color: var(--wood-teal-dark);
  color: #fff;
}

.slider {
  width: 50%;
  margin: 1rem 0
}

.slider__range {
  width: calc(100% - 50px)
}

.slider__number {
  width: 50px;
  margin-left: 1rem
}

.wg-form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + .75rem + 2px);
  padding: .25rem .5rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  background-clip: padding-box;
  background-color: transparent;
  border-bottom: 1px solid var(--grey2);
  border-left: 0;
  border-right: 0;
  border-top: 0;
  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}

.wg-form-control--alerts {
  display: block;
  width: 150px;
  height: calc(1.5em + .75rem + 2px);
  padding: .25rem .5rem;
  margin-bottom: 10px;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  background-clip: padding-box;
  background-color: transparent;
  border-bottom: 1px solid var(--grey2);
  border-left: 0;
  border-right: 0;
  border-top: 0;
  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}

.wg-form-control--white {
  background-color: #fff;
}

.wg-form-control--sm {
  width: 50px
}

.wg-form-control--auto {
  width: auto;
}

.wg-form-control.hc-has-error,
select.hc-has-error {
  border-bottom: 1px solid var(--red);
  background-color: var(--light-red);
}

.wg-form-control:active,
.wg-form-control:focus,
select:active,
select:focus,
input[type=text]:active,
input[type=text]:focus {
  outline: none;
}

/* login form control */
.lg-form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + .75rem + 2px);
  padding: .25rem .5rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  background-clip: padding-box;
  background-color: transparent;
  border-bottom: 1px solid var(--grey2);
  border-left: 0;
  border-right: 0;
  border-top: 0;
  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}

.lg-button {
  background-color: transparent;
  text-align: 'center';
  color: #fff;
  cursor: pointer;
  margin: 0 auto;
  outline: none;
  padding: 0.6rem 2.3rem;
  border: 2px solid var(--wood-teal);
  font-weight: bold;
  font-size: 15px;
}

.lg-form-group {
  margin-bottom: 1rem;
}

.lg-btn {
  display: inline-block;
  font-weight: 400;
  color:#ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
}

.lg-button:hover {
  background-color: var(--wood-teal);
}

.lg-form-control--white {
  background-color: #fff;
}

.lg-form-control--sm {
  width: 50px
}

.lg-form-control--auto {
  width: auto;
}

.lg-form-control.hc-has-error,
select.hc-has-error {
  border-bottom: 1px solid var(--red);
  background-color: var(--light-red);
}

.lg-form-control:active,
.lg-form-control:focus,
input[type=text]:active,
input[type=text]:focus {
  outline: none;
  background-color: #fff;
}

/* end login form control */

.hc-btn {
  cursor: pointer;
  color: var(--wood-teal);
  font-size: 1rem;
  background-color: transparent;
  border: none;
  padding: 0 .5rem
}

.hc-btn:hover,
.hc-btn:active,
.hc-btn:focus {
  color: var(--red);
  outline: none
}

.hc-btn--small {
  font-size: .75rem;
}

.hc-btn--grey {
  color: var(--wood-grey);
}

.hc-btn-offlimits {
  cursor: pointer;
  color: var(--grey4);
  font-size: 1rem;
  background-color: transparent;
  border: none;
  padding: 0 .5rem
}
.hc-btn-offlimits:hover,
.hc-btn-offlimits:active,
.hc-btn-offlimits:focus {
  color: var(--grey4);
  outline: none
}

.hc-nav-link {
  padding: .5rem 1rem
}

.hc-nav-link.active {
  background-color: var(--wood-teal);
  color: white;
}

.modal-xlg {
  max-width: 80%;
}

.wg-modal-body {
  padding: 2rem
}

.hc-grip {
  cursor: move;
  float: left;
  margin-right: .5rem;
  color: var(--grey4);
}

.hc-text {
  margin: 1rem 0;
}

.u-nowrap {
  white-space: nowrap;
}

/** already appears in style.css, but just put here for the sake of the mockup **/
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: .5rem 1rem;
  color: #fff;
  line-height: 1;
  background: rgba(35, 56, 69, 0.6);
  border-bottom: 1px solid rgba(35, 56, 69, 0);
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  font-size: 1rem;
}

.cell {
  display: flex;
}

.dot {
  display: block;
  height: 16px;
  width: 16px;
  background-color: transparent;
  border-radius: 50%;
  border: 2px solid var(--wood-grey);
}

.dot.active {
  background-color: var(--wood-teal);
  border-color: var(--wood-grey);
}

.dot.visited {
  background-color: #fff;
}

.dot.visited:hover,
.dot.active:hover {
  background-color: var(--wood-teal-dark);
  cursor: pointer;
}

/*copied from styles.css*/

.key__item {
  width: 2rem;
  height: 2rem;
  line-height: 2rem;
  text-align: center;
  font-weight: 700
}

.key__item--lev01 {
  background-color: rgb(148, 216, 100);
  background-color: hsl(var(--level01));
}

.key__item--lev02 {
  background-color: rgb(239, 244, 113);
  background-color: hsl(var(--level02))
}

.key__item--lev03 {
  background-color: rgb(253, 201, 78);
  background-color: hsl(var(--level03))
}

.key__item--lev04 {
  background-color: rgb(238, 107, 63);
  background-color: hsl(var(--level04));
  color: white
}

.key__item--lev05 {
  background-color: rgb(211, 42, 39);
  background-color: hsl(var(--level05));
  color: white
}

.hc-message {
  border-left-width: 2px;
  border-left-style: solid;
  margin-top: .5rem;
  padding: .5rem 1rem
}

.hc-message--error {
  background-color: var(--light-red);
  fill: var(--red);
  color: var(--red);
  border-left-color: var(--red);
}

.dropdown-toggle {
  font-size: 14px;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: .5rem 0;
  margin: 8px 0 0;
  font-size: 1rem;
  color: #fff;
  text-align: left;
  list-style: none;
  background-color: #7B888F;
  background-clip: padding-box;
  border: none;
  border-radius: 0;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
}

.dropdown-item {
  padding: .5rem 1rem;
  color: #fff;
}

.user-name {
  padding-left: .5rem
}

.wg-btn {
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 27px;
  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  color: #fff;
  border-radius: 27px;
  font-weight: 700;
  padding: .5rem 1.7rem;
}

.wg-btn:hover {
  opacity: .7;
  color: #fff
}

.wg-btn--grey {
  background-color: var(--wood-grey);
}

.wg-btn--teal {
  background-color: var(--wood-teal);
}

.dv-background {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-size: cover;
  z-index: -1;
}

.dv-login {
  width: 300px;
  margin: calc(50vh - 147px) auto 0 auto;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
}

.dv-login__logo {
  margin: 0 auto 3.5rem auto;
  width: 70%;
}

.dv-login__body {
  padding: 2rem;
}

.dv-login__body--dark {
  background-color: var(--wood-grey);
  color: #fff;
}

.dv-login__body--light {
  background-color: #fff;
  color: var(--wood-grey)
}

.dv-login__loading--spinner {
  align-items: center;
  margin-top: 0;
  margin-bottom: 0;
  text-align: center;
}

.dv-login-error-msg {
  color: red;
}

.wg-form__switch {
  display: block;
  height: 34px;
  position: relative;
  width: 60px;
  margin-bottom: 0;
}

.wg-form__switch input {
  display: none;
}

.wg-form__switch-slider {
  background-color: #ccc;
  bottom: 0;
  cursor: pointer;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  transition: .4s;
  border-radius: 34px;
}

.wg-form__switch-slider:before {
  background-color: #fff;
  bottom: 4px;
  content: "";
  height: 26px;
  left: 4px;
  position: absolute;
  transition: .4s;
  width: 26px;
  border-radius: 50%;
}

input:checked + .wg-form__switch-slider {
  background-color: #5DDB3D;
}

input:checked + .wg-form__switch-slider:before {
  transform: translateX(26px);
}

.hc-table td {
  padding: 0 1.5rem 1rem 0
}

.dropdown-user {
  margin-left: 1.5rem
}

.u-width-265 {
  width: 265px !important
}
/* end mockup */

.accordion {
  background-color: #fff;
  color: #444;
  cursor: pointer;
  padding: 8px;
  width: 120%;
  border: none;
  text-align: left;
  outline: none;
  /* font-size: 15px; */
  transition: 0.4s;
  display: block;
}

.accordion:after {
  content: '\\02795'; /* Unicode character for "plus" sign (+) */
  font-size: 16px;
  color: #777;
  float: left;
  margin-right: 5px;
  }

.active, .accordion:hover {
  background-color: #eee;
}

.panel {
  /* padding: 0 18px; */
  display: none;
  background-color: white;
  width: 120%;
  overflow: hidden;
}

body {
  background-color: #ccc;
}

:root {

  /* Colours which apply to the risk levels */
  --level01: 95, 60%, 62%;
  --level02: 62, 85%, 70%;
  --level03: 42, 98%, 65%;
  --level04: 15, 84%, 59%;
  --level05: 1, 69%, 49%;

  /* Varying opacities */
  --opacity-standard: 0.8;
  --opacity-muted: 0.4;

  /* Brand colours */
  --wood-grey: #233845;
  --wood-grey-translucent: rgba(35, 56, 69, .9);
  --wood-green: rgba(136, 197, 64, 1);
  --wood-teal: rgba(45, 189, 182, 1);
  --wood-teal-light: rgba(45, 189, 182, 0.1);
  --wood-teal-dark: rgb(89, 137, 135);
  --wood-purple: rgba(136, 76, 145, 1);

  --grey1: #f3f3f3;
  --grey2: #ced4da;
  --grey3: #adbcbb;
  --grey4: #849faf;
  --grey5: #E7EBEC;
  --grey5-translucent: rgba(231, 235, 236, .8);

  --notification-yellow: #ecd21b;

  --red: #d04435;
  --light-red: #f9e8e6;
}

*,
*::before,
*::after {
  box-sizing: border-box
}

html {
  font-size: 14px
}

body {
  margin: 0;
  padding: 0;
  line-height: 1.6;
  font-size: 1rem;
  font-family: 'Montserrat', sans-serif;
  color: #233845;
  background-color: #fff
}

hr {
  margin-top: 5px;
  margin-bottom: 5px;
  border-color: #777
}

a {
  color: var(--wood-teal)
}
/* ************************************************************************** */
/* header at the top of the page **********************************************/
/* ************************************************************************** */
.header {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: .75rem 1rem;
  color: white;
  line-height: 1;
  background-color: var(--wood-grey);
  border-bottom: 1px solid rgba(35, 56, 69, 0);
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  font-size: 1rem;
}

.header--overlaid {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  background-color: var(--wood-grey-translucent);
}

.header__logo {
  height: 20px;
  width: auto;
}

.header__logo-clickable {
  cursor: pointer;
}

.header__text {
  line-height: 11px;
  margin-top: 10px;
}

.header__logout {
  float: right
}

/* ************************************************************************** */
/* content - all content that is not in a header or a footer **************** */
/* ************************************************************************** */
.content {
  padding: 0.5rem;
  flex: 1
}

/* ************************************************************************** */
/* message-banner  ********************************************************** */
/* ************************************************************************** */
.message-banner {
  display: flex
}

.message-banner__message {
  padding: 1rem 2.5rem;
  flex: 1 1 0;
  font-size: 14px;
  text-decoration: none;
  flex-basis: calc(100% /3); /* this is only needed becuase IE11 doesn't support some elements of flex box */
}

.message-banner__message--warning {
  background-color: #F30202;
  color: white
}

.message-banner__message--watch {
  background-color: #fece7c;
  color: #233845
}

.message-banner__message--advisory {
  background-color: #83837f;
  color: white
}

.message-banner__message--clear {
  background-color:#eee;
  color: #233845
}

.message-banner__text {
  display: block;
  font-weight: 700
}

.message-banner__date {
  display: block;
  font-size: 14px
}

.message-banner__text-wrap {
  display: flex;
  justify-content: space-between
}

@media screen and (max-width: 1024px) {
  .message-banner,
  .message-banner__message {
    display: block;
    width: 100%
  }
}

/* ************************************************************************** */
/* table-info - contains information above the table  *********************** */
/* ************************************************************************** */
.table-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 1rem 0;
}

.table-info--padded {
  padding-left: 1.5rem
}

.table-heading {
  font-size: 24px
}

@media screen and (max-width: 700px) {
  .table-info {
    display: block;
    margin-bottom: 0
  }
}

/* ************************************************************************** */
/* key   ******************************************************************** */
/* ************************************************************************** */
.key {
  width: auto;
  padding: 0 1rem;
  background-color:#eee;
  border-radius: 25px;
  display: flex;
  align-items: center;
}

.key__activity {
  background-color:#eee;
}

.key__title {
  margin-right: 1rem;
  padding-right: 1rem;
  color: #777;
  border-right: 1px solid var(--grey3)
}

.key__keys {
  display: flex;
  align-items: center
}

.key__items {
  display: flex;
  align-items: center;
  margin: 0 1rem
}

.key__item {
  width: 2rem;
  height: 2rem;
  line-height: 2rem;
  text-align: center;
  font-weight: 700
}

.key__item--lev01 {
  background-color: rgb(148, 216, 100);
  background-color: hsl(var(--level01));
}

.key__item--lev02 {
  background-color: rgb(239, 244, 113);
  background-color: hsl(var(--level02))
}

.key__item--lev03 {
  background-color: rgb(253, 201, 78);
  background-color: hsl(var(--level03))
}

.key__item--lev04 {
  background-color: rgb(238, 107, 63);
  background-color: hsl(var(--level04));
  color: white
}

.key__item--lev05 {
  background-color: rgb(211, 42, 39);
  background-color: hsl(var(--level05));
  color: white
}


@media screen and (max-width: 700px) {
  .key {
    width: 100%;
    display: block;
    float: none;
    margin-top: 1rem
  }

  .key__title {
    margin: 0 0 1rem 0;
    padding-right: 0;
    border: 0;
    text-align: center
  }

  .key__keys {
    width: 231px;
    margin: auto;
  }
}

.fixed_header tbody{
  display:block;
  overflow: auto;
  height: 100px;
}

/* ************************************************************************** */
/* the risk table  ********************************************************** */
/* ************************************************************************** */
.rd-table {
  width: 100%;
  table-layout: fixed;
  font-size: 1rem;
}

.rd-table td,
.rd-table th {
  padding: .5rem;
  border-bottom: 1px solid rgba(224, 224, 224, 1)
}

.rd-table td:first-child,
.rd-table th:first-child {
  padding-left: 0;
}

.rd-table td:last-child,
.rd-table th:last-child {
  padding-right: 0;
}

.rd-table__location-cell {
  width: 200px;
  vertical-align: middle;
  font-weight: 700
}

.rd-table__location-text {
  display: flex;
  justify-content: space-between;
}

.rd-table__location-text > * + * {
  margin-left: 1rem
}

.rd-table__icons-wrap {
  width: 16px;
  text-align: center;
  display: flex;
  flex-direction: column;
}

.rd-table__icons-wrap > * + * {
  margin-top: 1rem
}

.rd-table__location-icon {
  cursor: pointer;
  color: var(--grey3)
}

.rd-table__location-icon.active {
  color: var(--notification-yellow)
}

.rd-table__location-header {
  text-align: left
}
.rd-table__date-header {
  text-align: center
}

.rd-table__hazard-header {
  width: 185px
}

.rd-table__obs-header {
  width: 210px;
}
.rd-table__risk-cell {
  border-radius: 27px;
  height: 54px
}

.rd-corner__risk-cell {
  border-radius: 30px;
  height: 100%;
  padding: 3px 3px 3px 10px;
}

.rd-table__obs-cell {
  text-align: center;
}

.rd-table__obs-name {
  font-size: 12px;
}

.rd-table__obs-value {
  font-weight: 700;
  line-height: 1;
}

.rd-table__obs-time {
  font-size: 12px;
}

.rd-table__icon-cell {
  width: 50px
}
.rd-table__risk-info {
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 9px 0 14px;
  width: 100%;
  text-decoration: none;
  cursor: pointer;
}

.rd-table__risk-text {
  flex: 1;
  font-weight: 700;
  margin-right: 4px;
}

.rd-table__risk-number {
  text-align: center;
  line-height: 36px;
  font-size: 1.25rem;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  font-weight: 700;
  flex-shrink: 0
}

.rd-table__risk-activity {
  text-align: left;
  line-height: 36px;
  font-size: 1.75rem;
  width: 36px;
  border-radius: 50%;
  font-weight: 700;
}

.rd-table__risk-info:hover {
  text-decoration: none
}

.rd-table__image {
  max-width: 100%
}

.rd-table__risk-cell--lev01 {
  background-color: rgba(148, 216, 100, .4);
  background-color: hsla(var(--level01),var(--opacity-muted))
}

.rd-table__risk-cell--lev02 {
  background-color: rgba(239, 244, 113, .4);
  background-color: hsla(var(--level02),var(--opacity-muted))
}

.rd-table__risk-cell--lev03 {
  background-color: rgba(253, 201, 78, .8);
  background-color: hsla(var(--level03),var(--opacity-standard))
}

.rd-table__risk-cell--lev04 {
  background-color: rgba(238, 107, 63, .8);
  background-color: hsla(var(--level04),var(--opacity-standard));
  color: white
}

.rd-table__risk-cell--lev05 {
  background-color: rgba(211, 42, 39, .8);
  background-color: hsla(var(--level05),var(--opacity-standard));
  color: white
}

.rd-table__risk-cell--lev01 .rd-table__risk-number {
  background-color: rgb(148, 216, 100);
  background-color: hsl(var(--level01))
}

.rd-table__risk-cell--lev02 .rd-table__risk-number {
  background-color: rgb(239, 244, 113);
  background-color: hsl(var(--level02))
}

.rd-table__risk-cell--lev03 .rd-table__risk-number {
  background-color: rgb(253, 201, 78);
  background-color: hsl(var(--level03))
}

.rd-table__risk-cell--lev04 .rd-table__risk-number {
  background-color: rgb(238, 107, 63);
  background-color: hsl(var(--level04));
  color: white
}

.rd-table__risk-cell--lev05 .rd-table__risk-number {
  background-color: rgb(211, 42, 39);
  background-color: hsl(var(--level05));
  color: white
}

.rd-table__risk-cell--lev01 .rd-table__risk-info,
.rd-table__risk-cell--lev02 .rd-table__risk-info,
.rd-table__risk-cell--lev03 .rd-table__risk-info {
  color: #233845
}


.rd-table__risk-cell--lev04 .rd-table__risk-info,
.rd-table__risk-cell--lev05 .rd-table__risk-info {
  color: white
}

.rd-table__icon {
  width: 24px;
  height: 24px;
  display: block
}

@media screen and (max-width: 1024px) {
  .rd-table thead {
    border: none;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px
  }

  .rd-table tr {
    border-bottom: 3px solid #ddd;
    display: block;
    margin-bottom: 2rem
  }


  .rd-table td {
    border-bottom: 1px solid #ddd;
    display: flex;
    flex-wrap: wrap
  }

  .rd-table .rd-table__timeline-cell {
    display: block
  }

  .rd-table td > * {
    flex: 1 0 50%
  }

  .rd-table td::before {
    content: attr(data-label);
    font-weight: 700;
    flex: 1 0 50%;
    align-self: center;
    padding-right: 1.5rem;
    color: #233845
  }

  .rd-table .rd-table__timeline-cell::before {
    width: 100%;
    margin-bottom: .5rem;
    display: block
  }

  .rd-table .rd-table__location-cell {
    width: auto;
    background-color: #ddd;
    line-height: 1.5;
  }

  .rd-table__risk-cell {
    width: 50%;
    float: left
  }

  }


/* ************************************************************************** */
/* aggregated risk timeline component *************************************** */
/* ************************************************************************** */
.timeline {
  display: flex
}

.timeline__block {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  border-left: 0.5px solid rgba(224, 224, 224, 1)
}

/* if a day has one block of readings */
.timeline__block--1block {
  flex: 0 0 calc((100% / 5) * (1 / 24));
}

.timeline__block--1block .timeline__label--1hr,
.timeline__block--1block .timeline__unit--1hr {
  flex: 0 0 calc(100% / 1)
}

/* if a day has two blocks of readings */
.timeline__block--2block {
  flex: 0 0 calc((100% / 5) * (2 / 24));
}

.timeline__block--2block .timeline__label--1hr,
.timeline__block--2block .timeline__unit--1hr {
  flex: 0 0 calc(100% / 2)
}

/* if a day has three blocks of readings */
.timeline__block--3block {
  flex: 0 0 calc((100% / 5) * (3 / 24));
}

.timeline__block--3block .timeline__label--1hr,
.timeline__block--3block .timeline__unit--1hr {
  flex: 0 0 calc(100% / 3)
}

/* if a day has four blocks of readings */
.timeline__block--4block {
  flex: 0 0 calc((100% / 5) * (4 / 24));
}

.timeline__block--4block .timeline__label--1hr,
.timeline__block--4block .timeline__unit--1hr {
  flex: 0 0 calc(100% / 4)
}

/* if a day has five blocks of readings */
.timeline__block--5block {
  flex: 0 0 calc((100% / 5) * (5 / 24));
}

.timeline__block--5block .timeline__label--1hr,
.timeline__block--5block .timeline__unit--1hr {
  flex: 0 0 calc(100% / 5)
}

/* if a day has six blocks of readings */
.timeline__block--6block {
  flex: 0 0 calc((100% / 5) * (6 / 24));
}

.timeline__block--6block .timeline__label--1hr,
.timeline__block--6block .timeline__unit--1hr {
  flex: 0 0 calc(100% / 6)
}

/* if a day has seven blocks of readings */
.timeline__block--7block {
  flex: 0 0 calc((100% / 5) * (7 / 24));
}

.timeline__block--7block .timeline__label--1hr,
.timeline__block--7block .timeline__unit--1hr {
  flex: 0 0 calc(100% / 7)
}

/* if a day has eight blocks of readings */
.timeline__block--8block {
  flex: 0 0 calc((100% / 5) * (8 / 24));
}

.timeline__block--8block .timeline__label--1hr,
.timeline__block--8block .timeline__unit--1hr {
  flex: 0 0 calc(100% / 8)
}

/* if a day has nine blocks of readings */
.timeline__block--9block {
  flex: 0 0 calc((100% / 5) * (9 / 24));
}

.timeline__block--9block .timeline__label--1hr,
.timeline__block--9block .timeline__unit--1hr {
  flex: 0 0 calc(100% / 9)
}

/* if a day has ten blocks of readings */
.timeline__block--10block {
  flex: 0 0 calc((100% / 5) * (10 / 24));
}

.timeline__block--10block .timeline__label--1hr,
.timeline__block--10block .timeline__unit--1hr {
  flex: 0 0 calc(100% / 10)
}

/* if a day has eleven blocks of readings */
.timeline__block--11block {
  flex: 0 0 calc((100% / 5) * (11 / 24));
}

.timeline__block--11block .timeline__label--1hr,
.timeline__block--11block .timeline__unit--1hr {
  flex: 0 0 calc(100% / 11)
}

/* if a day has twelve blocks of readings */
.timeline__block--12block {
  flex: 0 0 calc((100% / 5) * (12 / 24));
}

.timeline__block--12block .timeline__label--1hr,
.timeline__block--12block .timeline__unit--1hr {
  flex: 0 0 calc(100% / 12)
}

/* if a day has thirteen blocks of readings */
.timeline__block--13block {
  flex: 0 0 calc((100% / 5) * (13 / 24));
}

.timeline__block--13block .timeline__label--1hr,
.timeline__block--13block .timeline__unit--1hr {
  flex: 0 0 calc(100% / 13)
}

/* if a day has fourteen blocks of readings */
.timeline__block--14block {
  flex: 0 0 calc((100% / 5) * (14 / 24));
}

.timeline__block--14block .timeline__label--1hr,
.timeline__block--14block .timeline__unit--1hr {
  flex: 0 0 calc(100% / 14)
}

/* if a day has fifteen blocks of readings */
.timeline__block--15block {
  flex: 0 0 calc((100% / 5) * (15 / 24));
}

.timeline__block--15block .timeline__label--1hr,
.timeline__block--15block .timeline__unit--1hr {
  flex: 0 0 calc(100% / 15)
}

/* if a day has sixteen blocks of readings */
.timeline__block--16block {
  flex: 0 0 calc((100% / 5) * (16 / 24));
}

.timeline__block--16block .timeline__label--1hr,
.timeline__block--16block .timeline__unit--1hr {
  flex: 0 0 calc(100% / 16)
}

/* if a day has seventeen blocks of readings */
.timeline__block--17block {
  flex: 0 0 calc((100% / 5) * (17 / 24));
}

.timeline__block--17block .timeline__label--1hr,
.timeline__block--17block .timeline__unit--1hr {
  flex: 0 0 calc(100% / 17)
}

/* if a day has eighteen blocks of readings */
.timeline__block-18block {
  flex: 0 0 calc((100% / 5) * (18 / 24));
}

.timeline__block--18block .timeline__label--1hr,
.timeline__block--18block .timeline__unit--1hr {
  flex: 0 0 calc(100% / 18)
}

/* if a day has nineteen blocks of readings */
.timeline__block--19block {
  flex: 0 0 calc((100% / 5) * (19 / 24));
}

.timeline__block--19block .timeline__label--1hr,
.timeline__block--19block .timeline__unit--1hr {
  flex: 0 0 calc(100% / 19)
}

/* if a day has twenty blocks of readings */
.timeline__block--20block {
  flex: 0 0 calc((100% / 5) * (20 / 24));
}

.timeline__block--20block .timeline__label--1hr,
.timeline__block--20block .timeline__unit--1hr {
  flex: 0 0 calc(100% / 20)
}

/* if a day has twenty-one blocks of readings */
.timeline__block--21block {
  flex: 0 0 calc((100% / 5) * (21 / 24));
}

.timeline__block--21block .timeline__label--1hr,
.timeline__block--21block .timeline__unit--1hr {
  flex: 0 0 calc(100% / 21)
}

/* if a day has twenty-two blocks of readings */
.timeline__block--22block {
  flex: 0 0 calc((100% / 5) * (22 / 24));
}

.timeline__block--22block .timeline__label--1hr,
.timeline__block--22block .timeline__unit--1hr {
  flex: 0 0 calc(100% / 22)
}

/* if a day has twenty-three blocks of readings */
.timeline__block--23block {
  flex: 0 0 calc((100% / 5) * (23 / 24));
}

.timeline__block--23block .timeline__label--1hr,
.timeline__block--23block .timeline__unit--1hr {
  flex: 0 0 calc(100% / 23)
}

/* if a day has twenty-four blocks of readings - this is a full 24 hour period  */
.timeline__block--24block {
  flex: 0 0 calc(100% / 5);
}

.timeline__block--24block .timeline__label--1hr,
.timeline__block--24block .timeline__unit--1hr {
  flex-basis: calc(100% / 24)
}

.timeline__label--1hr:before {
  content: attr(data-content);
  display: block;
  width: 13px;
  height: 12px;
  position: absolute;
  z-index: 1;
}

.timeline__row {
  display: flex;
}

.timeline__row--dates {
  justify-content: center;
  padding-bottom: .5rem
}

.timeline__row--labels {
  text-align: left;
  height: 12px;
}

.timeline__unit {
  height: 32px;
  position: relative;
}

.timeline__label {
  font-size: 8px;
  position: relative;
}

.timeline__label--1hr {
  text-align: left;
  padding-left: 1px
}

.timeline__label--1hr:not(:last-child) {
  border-right: 1px solid rgba(224, 224, 224, 1);
}

.timeline__unit {
  border-right: 1px solid white
}

.timeline__unit--lev00 {
  background-color: rgb(230,230,230);
}

.timeline__unit--lev01 {
  background-color: rgb(148, 216, 100);
  background-color: hsl(var(--level01));
}

.timeline__unit--lev02 {
  background-color: rgb(239, 244, 113);
  background-color: hsl(var(--level02))
}

.timeline__unit--lev03 {
  background-color: rgb(253, 201, 78);
  background-color: hsl(var(--level03))
}

.timeline__unit--lev04 {
  background-color: rgb(238, 107, 63);
  background-color: hsl(var(--level04));
}

.timeline__unit--lev05 {
  background-color: rgb(211, 42, 39);
  background-color: hsl(var(--level05));
}

.timeline__unit--nolev {
  background-color: rgb(255, 255, 255);
}

.timeline__unit--daynight {
  background-color: rgb(210, 210, 210);
}

@media screen and (max-width: 767px) {

  .timeline {
    width: 767px
  }

  .timeline-wrapper {
    overflow-x: auto
  }

}

/* ************************************************************************** */
/* text and icon component ************************************************** */
/* ************************************************************************** */
.text-and-icon {
  display: flex;
  text-decoration: none;
  width: max-content;
  color: inherit;
  align-items: center;
}

.text-and-icon__mod {
  text-decoration: none;
  width: max-content;
  color: inherit
}

.text-and-icon--small {
  font-size: 12px
}

.text-and-icon--bold {
  font-weight: 700;
}

.text-and-icon--grey {
  color: #777
}

.text-and-icon--align-center {
  align-items: center
}

.text-and-icon:not(:first-child) {
  margin-top: .75rem
}

.text-and-icon__icon {
  width: 16px;
  height: 16px
}

.text-and-icon__text--right {
  margin-left: .5rem
}

.text-and-icon__text--left {
  margin-right: .5rem
}

.cursor-pointer {
  cursor: pointer;
}

/* ************************************************************************** */
/* a list of links ********************************************************** */
/* ************************************************************************** */
.links {
  display: flex;
  background: #ccc
}

.links a {
  padding: 1rem;
  text-decoration: none;
  color: inherit
}

.links .current {
  background: #fff
}

/* ************************************************************************** */
/* overriding bootstrap tooltips ******************************************** */
/* ************************************************************************** */
.tooltip {
  font-size: 14px;
  font-family: 'Montserrat';
  position: fixed;
}

.tooltip.top {
  margin-top: 0
}

.tooltip.right .tooltip-arrow {
  border-right-color: #233845
}

.tooltip-inner {
  background-color: #233845;
  padding: .5rem 1rem
}

.tooltip.in {
  opacity: 1
}

/* ************************************************************************** */
/* overriding bootstrap modal *********************************************** */
/* ************************************************************************** */
.modal {
  background: rgba(0, 0, 0, 0.5)
}

.modal-dialog {
  max-width: 90%
}

.modal-content {
  border-radius: 0
}

.modal-body__image {
  max-width: 100%
}

.modal-header {
  font-size: 1.5rem
}

.modal__button {
  font-weight: 700
}


/**** NEW *****/
.wg-page-wrapper {
  display: flex;
}

.wg-column {
  display: flex;
  flex-direction: column;
}

.wg-row {
  display: flex;
  align-items: center;
}

.wg-row-header {
  display: flex;
  align-items: center;
  height: 70px;
}

.wg-heading-cell--175 {
  padding: 0.5rem;
  font-weight: bold;
  text-align: center;
  width: 175px
}

.wg-table-cell--175 {
  padding: 0.5rem;
  width: 175px
}

.wg-heading-cell--200 {
  padding: 0.5rem;
  font-weight: bold;
  text-align: center;
  width: 175px
}

.wg-table-cell--200 {
  padding: 0.5rem;
  width: 200px
}

.wg-timelines-wrapper {
  flex-grow: 1;
}

.wg-row--dates {
  font-weight: 700;
  text-align: center;
  align-items: flex-end;
  padding-bottom: 0.5rem;
  height: 40px;
}

.wg-row--timeline {
  height: 48px;
}

.wg-row--timeline-timezone {
  text-align: center;
  height: 30px;
  
}

/*

FORECAST DAYS STYLES
====================

for forecasts of 5 days or less, make it use flexbox and occupy the full width
of the screen. The widths of the timelines should be flexible

for forecasts of 6 days or more, set the widths of the timelines to be 300px -
hardcode them. They will need to scroll

*/

.forecast .timeline__block {
  flex: 0 0 300px;
}

.forecast .wg-scrollpane {
  overflow-x: scroll;
  padding: 0 .5rem;
}

.forecast--1day .wg-scrollpane,
.forecast--2day .wg-scrollpane,
.forecast--3day .wg-scrollpane,
.forecast--4day .wg-scrollpane,
.forecast--5day .wg-scrollpane {
  overflow-x: auto;
  padding: 0 .5rem;
}

/* ************************************************************************** */
/* 1 day forecast *********************************************************** */
/* ************************************************************************** */

.forecast--1day .timeline {
  width: 100%
}

.forecast--1day .timeline__block--1block {flex: 0 0 calc(100% * (1 / 24))}
.forecast--1day .timeline__block--2block {flex: 0 0 calc(100% * (2 / 24))}
.forecast--1day .timeline__block--3block {flex: 0 0 calc(100% * (3 / 24))}
.forecast--1day .timeline__block--4block {flex: 0 0 calc(100% * (4 / 24))}
.forecast--1day .timeline__block--5block {flex: 0 0 calc(100% * (5 / 24))}
.forecast--1day .timeline__block--6block {flex: 0 0 calc(100% * (6 / 24))}
.forecast--1day .timeline__block--7block {flex: 0 0 calc(100% * (7 / 24))}
.forecast--1day .timeline__block--8block {flex: 0 0 calc(100% * (8 / 24))}
.forecast--1day .timeline__block--9block {flex: 0 0 calc(100% * (9 / 24))}
.forecast--1day .timeline__block--10block {flex: 0 0 calc(100% * (10 / 24))}
.forecast--1day .timeline__block--11block {flex: 0 0 calc(100% * (11 / 24))}
.forecast--1day .timeline__block--12block {flex: 0 0 calc(100% * (12 / 24))}
.forecast--1day .timeline__block--13block {flex: 0 0 calc(100% * (13 / 24))}
.forecast--1day .timeline__block--14block {flex: 0 0 calc(100% * (14 / 24))}
.forecast--1day .timeline__block--15block {flex: 0 0 calc(100% * (15 / 24))}
.forecast--1day .timeline__block--16block {flex: 0 0 calc(100% * (16 / 24))}
.forecast--1day .timeline__block--17block {flex: 0 0 calc(100% * (17 / 24))}
.forecast--1day .timeline__block--18block {flex: 0 0 calc(100% * (18 / 24))}
.forecast--1day .timeline__block--19block {flex: 0 0 calc(100% * (19 / 24))}
.forecast--1day .timeline__block--20block {flex: 0 0 calc(100% * (20 / 24))}
.forecast--1day .timeline__block--21block {flex: 0 0 calc(100% * (21 / 24))}
.forecast--1day .timeline__block--22block {flex: 0 0 calc(100% * (22 / 24))}
.forecast--1day .timeline__block--23block {flex: 0 0 calc(100% * (23 / 24))}
.forecast--1day .timeline__block--24block {flex: 0 0 100%}

/* ************************************************************************** */
/* 2 day forecast *********************************************************** */
/* ************************************************************************** */

.forecast--2day .timeline {
  width: 100%
}

.forecast--2day .timeline__block--1block {flex: 0 0 calc((100% / 2) * (1 / 24))}
.forecast--2day .timeline__block--2block {flex: 0 0 calc((100% / 2) * (2 / 24))}
.forecast--2day .timeline__block--3block {flex: 0 0 calc((100% / 2) * (3 / 24))}
.forecast--2day .timeline__block--4block {flex: 0 0 calc((100% / 2) * (4 / 24))}
.forecast--2day .timeline__block--5block {flex: 0 0 calc((100% / 2) * (5 / 24))}
.forecast--2day .timeline__block--6block {flex: 0 0 calc((100% / 2) * (6 / 24))}
.forecast--2day .timeline__block--7block {flex: 0 0 calc((100% / 2) * (7 / 24))}
.forecast--2day .timeline__block--8block {flex: 0 0 calc((100% / 2) * (8 / 24))}
.forecast--2day .timeline__block--9block {flex: 0 0 calc((100% / 2) * (9 / 24))}
.forecast--2day .timeline__block--10block {flex: 0 0 calc((100% / 2) * (10 / 24))}
.forecast--2day .timeline__block--11block {flex: 0 0 calc((100% / 2) * (11 / 24))}
.forecast--2day .timeline__block--12block {flex: 0 0 calc((100% / 2) * (12 / 24))}
.forecast--2day .timeline__block--13block {flex: 0 0 calc((100% / 2) * (13 / 24))}
.forecast--2day .timeline__block--14block {flex: 0 0 calc((100% / 2) * (14 / 24))}
.forecast--2day .timeline__block--15block {flex: 0 0 calc((100% / 2) * (15 / 24))}
.forecast--2day .timeline__block--16block {flex: 0 0 calc((100% / 2) * (16 / 24))}
.forecast--2day .timeline__block--17block {flex: 0 0 calc((100% / 2) * (17 / 24))}
.forecast--2day .timeline__block--18block {flex: 0 0 calc((100% / 2) * (18 / 24))}
.forecast--2day .timeline__block--19block {flex: 0 0 calc((100% / 2) * (19 / 24))}
.forecast--2day .timeline__block--20block {flex: 0 0 calc((100% / 2) * (20 / 24))}
.forecast--2day .timeline__block--21block {flex: 0 0 calc((100% / 2) * (21 / 24))}
.forecast--2day .timeline__block--22block {flex: 0 0 calc((100% / 2) * (22 / 24))}
.forecast--2day .timeline__block--23block {flex: 0 0 calc((100% / 2) * (23 / 24))}
.forecast--2day .timeline__block--24block {flex: 0 0 calc(100% / 2)}


/* ************************************************************************** */
/* 3 day forecast *********************************************************** */
/* ************************************************************************** */
.forecast--3day .timeline {
  width: 100%
}

.forecast--3day .timeline__block--1block {flex: 0 0 calc((100% / 3) * (1 / 24))}
.forecast--3day .timeline__block--2block {flex: 0 0 calc((100% / 3) * (2 / 24))}
.forecast--3day .timeline__block--3block {flex: 0 0 calc((100% / 3) * (3 / 24))}
.forecast--3day .timeline__block--4block {flex: 0 0 calc((100% / 3) * (4 / 24))}
.forecast--3day .timeline__block--5block {flex: 0 0 calc((100% / 3) * (5 / 24))}
.forecast--3day .timeline__block--6block {flex: 0 0 calc((100% / 3) * (6 / 24))}
.forecast--3day .timeline__block--7block {flex: 0 0 calc((100% / 3) * (7 / 24))}
.forecast--3day .timeline__block--8block {flex: 0 0 calc((100% / 3) * (8 / 24))}
.forecast--3day .timeline__block--9block {flex: 0 0 calc((100% / 3) * (9 / 24))}
.forecast--3day .timeline__block--10block {flex: 0 0 calc((100% / 3) * (10 / 24))}
.forecast--3day .timeline__block--11block {flex: 0 0 calc((100% / 3) * (11 / 24))}
.forecast--3day .timeline__block--12block {flex: 0 0 calc((100% / 3) * (12 / 24))}
.forecast--3day .timeline__block--13block {flex: 0 0 calc((100% / 3) * (13 / 24))}
.forecast--3day .timeline__block--14block {flex: 0 0 calc((100% / 3) * (14 / 24))}
.forecast--3day .timeline__block--15block {flex: 0 0 calc((100% / 3) * (15 / 24))}
.forecast--3day .timeline__block--16block {flex: 0 0 calc((100% / 3) * (16 / 24))}
.forecast--3day .timeline__block--17block {flex: 0 0 calc((100% / 3) * (17 / 24))}
.forecast--3day .timeline__block--18block {flex: 0 0 calc((100% / 3) * (18 / 24))}
.forecast--3day .timeline__block--19block {flex: 0 0 calc((100% / 3) * (19 / 24))}
.forecast--3day .timeline__block--20block {flex: 0 0 calc((100% / 3) * (20 / 24))}
.forecast--3day .timeline__block--21block {flex: 0 0 calc((100% / 3) * (21 / 24))}
.forecast--3day .timeline__block--22block {flex: 0 0 calc((100% / 3) * (22 / 24))}
.forecast--3day .timeline__block--23block {flex: 0 0 calc((100% / 3) * (23 / 24))}
.forecast--3day .timeline__block--24block {flex: 0 0 calc(100% / 3)}


/* ************************************************************************** */
/* 4 day forecast *********************************************************** */
/* ************************************************************************** */
.forecast--4day .timeline {
  width: 100%
}

.forecast--4day .timeline__block--1block {flex: 0 0 calc((100% / 4) * (1 / 24))}
.forecast--4day .timeline__block--2block {flex: 0 0 calc((100% / 4) * (2 / 24))}
.forecast--4day .timeline__block--3block {flex: 0 0 calc((100% / 4) * (3 / 24))}
.forecast--4day .timeline__block--4block {flex: 0 0 calc((100% / 4) * (4 / 24))}
.forecast--4day .timeline__block--5block {flex: 0 0 calc((100% / 4) * (5 / 24))}
.forecast--4day .timeline__block--6block {flex: 0 0 calc((100% / 4) * (6 / 24))}
.forecast--4day .timeline__block--7block {flex: 0 0 calc((100% / 4) * (7 / 24))}
.forecast--4day .timeline__block--8block {flex: 0 0 calc((100% / 4) * (8 / 24))}
.forecast--4day .timeline__block--9block {flex: 0 0 calc((100% / 4) * (9 / 24))}
.forecast--4day .timeline__block--10block {flex: 0 0 calc((100% / 4) * (10 / 24))}
.forecast--4day .timeline__block--11block {flex: 0 0 calc((100% / 4) * (11 / 24))}
.forecast--4day .timeline__block--12block {flex: 0 0 calc((100% / 4) * (12 / 24))}
.forecast--4day .timeline__block--13block {flex: 0 0 calc((100% / 4) * (13 / 24))}
.forecast--4day .timeline__block--14block {flex: 0 0 calc((100% / 4) * (14 / 24))}
.forecast--4day .timeline__block--15block {flex: 0 0 calc((100% / 4) * (15 / 24))}
.forecast--4day .timeline__block--16block {flex: 0 0 calc((100% / 4) * (16 / 24))}
.forecast--4day .timeline__block--17block {flex: 0 0 calc((100% / 4) * (17 / 24))}
.forecast--4day .timeline__block--18block {flex: 0 0 calc((100% / 4) * (18 / 24))}
.forecast--4day .timeline__block--19block {flex: 0 0 calc((100% / 4) * (19 / 24))}
.forecast--4day .timeline__block--20block {flex: 0 0 calc((100% / 4) * (20 / 24))}
.forecast--4day .timeline__block--21block {flex: 0 0 calc((100% / 4) * (21 / 24))}
.forecast--4day .timeline__block--22block {flex: 0 0 calc((100% / 4) * (22 / 24))}
.forecast--4day .timeline__block--23block {flex: 0 0 calc((100% / 4) * (23 / 24))}
.forecast--4day .timeline__block--24block {flex: 0 0 calc(100% / 4)}


/* ************************************************************************** */
/* 5 day forecast *********************************************************** */
/* ************************************************************************** */
.forecast--5day .timeline {
  width: 100%
}

.forecast--5day .timeline__block--1block {flex: 0 0 calc((100% / 5) * (1 / 24))}
.forecast--5day .timeline__block--2block {flex: 0 0 calc((100% / 5) * (2 / 24))}
.forecast--5day .timeline__block--3block {flex: 0 0 calc((100% / 5) * (3 / 24))}
.forecast--5day .timeline__block--4block {flex: 0 0 calc((100% / 5) * (4 / 24))}
.forecast--5day .timeline__block--5block {flex: 0 0 calc((100% / 5) * (5 / 24))}
.forecast--5day .timeline__block--6block {flex: 0 0 calc((100% / 5) * (6 / 24))}
.forecast--5day .timeline__block--7block {flex: 0 0 calc((100% / 5) * (7 / 24))}
.forecast--5day .timeline__block--8block {flex: 0 0 calc((100% / 5) * (8 / 24))}
.forecast--5day .timeline__block--9block {flex: 0 0 calc((100% / 5) * (9 / 24))}
.forecast--5day .timeline__block--10block {flex: 0 0 calc((100% / 5) * (10 / 24))}
.forecast--5day .timeline__block--11block {flex: 0 0 calc((100% / 5) * (11 / 24))}
.forecast--5day .timeline__block--12block {flex: 0 0 calc((100% / 5) * (12 / 24))}
.forecast--5day .timeline__block--13block {flex: 0 0 calc((100% / 5) * (13 / 24))}
.forecast--5day .timeline__block--14block {flex: 0 0 calc((100% / 5) * (14 / 24))}
.forecast--5day .timeline__block--15block {flex: 0 0 calc((100% / 5) * (15 / 24))}
.forecast--5day .timeline__block--16block {flex: 0 0 calc((100% / 5) * (16 / 24))}
.forecast--5day .timeline__block--17block {flex: 0 0 calc((100% / 5) * (17 / 24))}
.forecast--5day .timeline__block--18block {flex: 0 0 calc((100% / 5) * (18 / 24))}
.forecast--5day .timeline__block--19block {flex: 0 0 calc((100% / 5) * (19 / 24))}
.forecast--5day .timeline__block--20block {flex: 0 0 calc((100% / 5) * (20 / 24))}
.forecast--5day .timeline__block--21block {flex: 0 0 calc((100% / 5) * (21 / 24))}
.forecast--5day .timeline__block--22block {flex: 0 0 calc((100% / 5) * (22 / 24))}
.forecast--5day .timeline__block--23block {flex: 0 0 calc((100% / 5) * (23 / 24))}
.forecast--5day .timeline__block--24block {flex: 0 0 calc(100% / 5)}

@media screen and (max-width: 1024px) {
  .u-hidden-mobile {
    display: none;
  }
}

/* Graph Charts */
.c3-line {
  stroke-width: 2.5px;
}

.btn {
  border: none;
  background-color: inherit;
  padding: 14px 28px;
  font-size: 16px;
  cursor: pointer;
  display: inline-block;
  }

.btn:hover {
  background: #eee;
}

.success {
  color: green;
}
.info {
  color: dodgerblue;
}

/* ************************************************************************** */
/* ******************** Map and leaflet controls **************************** */
/* ************************************************************************** */

.map-page-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.map-container {
  position: relative;
  display: flex;
  flex: 5;
}

.map {
  position: relative;
  display: flex;
  flex: 5;
}

.map > div {
  flex: 1;
}

.leaflet-top .leaflet-control {
    margin-top: 53px;
}

.leaflet-pane > svg path.leaflet-interactive:hover {
	fill: rgba(255,255,255,0.3)
}

/* Leaflet site icons */
.leaflet-div-icon {
    background: #fff;
    border: 1px solid #666;
}

/* reduce the size of the leaflet attribution, for some more space */
.leaflet-container .leaflet-control-attribution {
    font-size: 9px
}

.leaflet-popup-content-wrapper {
  background-color: rgba(0, 0, 0, 0.5) !important;
  color: white !important;
  font-size: 16px;
}

.leaflet-popup-tip {
  height: 5px !important;
  width: 5px !important;
  font-family: palatino;
  background-color: #bbb;
  border-radius: 50% !important;
  display: inline-block;
}
/* Cell */

.cell {
  display: flex;
}

.dot {
  display: block;
  height: 16px;
  width: 16px;
  background-color: transparent;
  border-radius: 50%;
  border: 2px solid var(--grey3);
}

.dot.active {
  background-color: #2dbdb6;
}

.dot.visited {
  background-color: white;
}

.dot.visited:hover,
.dot.active:hover {
  background-color: #598987;
  cursor: pointer;
}

/* Leaflet site icons */

.leaflet-div-icon {
  background: #fff;
  border: 1px solid #666;
}

.risk-icon-01 {
  border-radius: 50%;
  border: 5px solid rgb(148, 216, 100);
  background-color: rgb(148, 216, 100);
}

.risk-icon-02 {
  border-radius: 50%;
  border: 5px solid rgb(239, 244, 113);
  background-color: rgb(239, 244, 113);
}

.risk-icon-03 {
  border-radius: 50%;
  border: 5px solid rgb(253, 201, 78);
  background-color: rgb(253, 201, 78);
}

.risk-icon-04 {
  border-radius: 50%;
  border: 5px solid rgb(238, 107, 63);
  background-color: rgb(238, 107, 63);
}

.risk-icon-05 {
  border-radius: 50%;
  border: 5px solid rgb(211, 42, 39);
  background-color: rgb(211, 42, 39);
}

.risk-detail-panel {
  position: absolute;
  top: 50px;
  height: auto;
  width: 315px;
  background-color: white;
  z-index: 2000;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
}

.risk-detail-panel-left {
  left: 40px;
}

.risk-detail-panel-right {
  right: 50px;
}

.risk-detail-panel-header {
  border-bottom: 1px solid rgb(128, 128, 128);
  padding: .5rem 1rem;
}

.risk-detail-table {
  margin: 1rem 1rem .5rem 1rem
}

.risk-detail-table-row {
  display: flex;
  align-items: center;
  padding: .5rem;
  border-top: 1px solid #ccc;
}

.risk-detail-table-heading {
  font-size: 12px;
  color: #598987;
  font-weight: 700;
  display: flex;
  align-items: center;
  padding: 0 .5rem .25rem .5rem;
}

.risk-detail-table-row + .risk-detail-table-row {
  margin-top: .25rem
}

.risk-detail-table-date {
  min-width: 81px;
  width: 81px;
  margin-right: 1rem;
}

.risk-detail-hazard {
  font-weight: 700;
  padding: .25rem .75rem;
  min-height: 30px;
  border-radius: 15px;
  width: 100%;
}

/*******************************************************************************
  For styles have been copied from Bootstrap. I'm not including all of
  bootstrap.css because it has some unwanted effects with inheritance etc.

  Author: Beck Davies
  Date: March 12th, 2019

*******************************************************************************/

/* ************************************************************************** */
/* tooltips  **************************************************************** */
/* ************************************************************************** */
.tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  word-wrap: normal;
  white-space: normal;
  filter: alpha(opacity=0);
  opacity: 0;
  line-break: auto
}

.tooltip.in {
  filter: alpha(opacity=90);
  opacity: .9
}

.tooltip.top {
  padding: 5px 0;
  margin-top: -3px
}

.tooltip.right {
  padding: 0 5px;
  margin-left: 3px
}

.tooltip.bottom {
  padding: 5px 0;
  margin-top: 3px
}

.tooltip.left {
  padding: 0 5px;
  margin-left: -3px
}

.tooltip-inner {
  max-width: 200px;
  padding: 3px 8px;
  color: #fff;
  text-align: center;
  background-color: #000;
  border-radius: 4px
}

.tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid
}

.tooltip.top .tooltip-arrow {
  bottom: 0;
  left: 50%;
  margin-left: -5px;
  border-width: 5px 5px 0;
  border-top-color: #000
}

.tooltip.top-left .tooltip-arrow {
  right: 5px;
  bottom: 0;
  margin-bottom: -5px;
  border-width: 5px 5px 0;
  border-top-color: #000
}

.tooltip.top-right .tooltip-arrow {
  bottom: 0;
  left: 5px;
  margin-bottom: -5px;
  border-width: 5px 5px 0;
  border-top-color: #000
}

.tooltip.right .tooltip-arrow {
  top: 50%;
  left: 0;
  margin-top: -5px;
  border-width: 5px 5px 5px 0;
  border-right-color: #000
}

.tooltip.left .tooltip-arrow {
  top: 50%;
  right: 0;
  margin-top: -5px;
  border-width: 5px 0 5px 5px;
  border-left-color: #000
}

.tooltip.bottom .tooltip-arrow {
  top: 0;
  left: 50%;
  margin-left: -5px;
  border-width: 0 5px 5px;
  border-bottom-color: #000
}

.tooltip.bottom-left .tooltip-arrow {
  top: 0;
  right: 5px;
  margin-top: -5px;
  border-width: 0 5px 5px;
  border-bottom-color: #000
}

.tooltip.bottom-right .tooltip-arrow {
  top: 0;
  left: 5px;
  margin-top: -5px;
  border-width: 0 5px 5px;
  border-bottom-color: #000
}

/* ************************************************************************** */
/* modal   ****************************************************************** */
/* ************************************************************************** */
.modal-open {
  overflow: hidden;
  }

.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: none;
  overflow: hidden;
  outline: 0;
}

.modal-open .modal {
  overflow-x: hidden;
  overflow-y: auto;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: none;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - (0.5rem * 2));
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1040;
  background-color: #000;
}

.modal-backdrop.fade {
  opacity: 0;
}


.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem;
  border-bottom: 1px solid #e9ecef;
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
  }



  .modal-title {
  margin-bottom: 0;
  line-height: 1.5;
  }

  .modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1rem;
  }

  .modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 1rem;
  border-top: 1px solid #e9ecef;
  }

  .modal-footer > :not(:first-child) {
  margin-left: .25rem;
  }

  .modal-footer > :not(:last-child) {
  margin-right: .25rem;
  }

  .modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll;
  }

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto;
  }
  .modal-dialog-centered {
    min-height: calc(100% - (1.75rem * 2));
  }
  .modal-sm {
    max-width: 300px;
  }
}

@media (min-width: 992px) {
  .modal-lg {
    max-width: 800px;
  }
}

/* ************************************************************************** */
/* ******************** Dropdowns ******************************************* */
/* ************************************************************************** */
.dropdown {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}

.dropdown-toggle::after {
  display: inline-block;
  margin-left: .255em;
  vertical-align: .255em;
  content: "";
  border-top: .3em solid;
  border-right: .3em solid transparent;
  border-bottom: 0;
  border-left: .3em solid transparent;
}

.dropdown-menu-right {
  right: 0;
  left: auto;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: .5rem 0;
  margin: 8px 0 0;
  font-size: 1rem;
  color: #fff;
  text-align: left;
  list-style: none;
  background-color: #7B888F;
  background-clip: padding-box;
}

.dropdown-header {
  display: block;
  padding: .5rem 1.5rem;
  margin-bottom: 0;
  font-size: .875rem;
  color: #6c757d;
  white-space: nowrap;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: .25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}

/* ************************************************************************** */
/* ******************** Controls ******************************************** */
/* ************************************************************************** */
.controls-container {
  position: absolute;
  top: 10px;
  right: 8px;
  width: 40px;
  z-index: 1000;
}

.control-container {
  position: relative;
  padding-bottom: 10px;
}

.control-container__button {
  position: relative;
  width: 40px;
  height: 40px;
  color: white;
  background-color: #233845;
  cursor: pointer;
  border-radius: 50%;
  transition: background-color 0.5s ease;
  transition: background-color 0.5s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;
}

.control-container__button.open {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  background-color: rgb(70, 102, 138);
}

.control-container__panel {
  background-color: rgb(70, 102, 138);
  top: 0px;
  right: 40px;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  min-width: 35vh;
  position: absolute;
  max-height: 80vh;
  overflow-y: auto;
}

.control-container__panel-inner {
  padding: 8px;
}

.control-container__section {
  color: white;
}

.control-container__section + .control-container__section {
  margin-top: 1rem
}

.control-container__section-heading {
  font-weight: bold
}

.control-container__item-row {
  display: flex;
  align-items: center;
  padding-top: 5px;
  padding-top: 5px;
}

.control-container__item-select {
  flex-grow: 1;
  margin-right: .5rem;
  background: #233845;
  color: white;
  padding: .25rem;
  border-color: #7d9199;
}

.control-container__item-select > option {
  background: #233845;
}
.control-container__feature-group-list {
  list-style-type:none;
  padding:0px;
  margin:0px;
  margin-left:4px;
}
.control-container__feature-group-list input{
  list-style-type:none;
  padding:0px;
  margin:0px;
}
.control-container__feature-group-item-label{
  color:white;
  cursor: pointer;
}
.control-container__feature-list {
  list-style-type:none;
  padding:3px;
  margin:0px;
  margin-left:5px;
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.2s ease-out;
}
.control-container__feature-list input{
  list-style-type:none;
  padding:0px;
  margin:5px;
}
.control-container__feature-item-label{
  color:white;
  white-space: nowrap;
  margin-bottom: 10px;
  padding:10px;
  cursor:pointer;
}
.control-container__feature-item-number-input {
  background: #233845;
  color: white;
  padding: .25rem;
  margin-left: 4px;
  border-color: #7d9199;
  width: 30%;
}
.control-container-feature-group-collapsible {
  cursor: pointer;
  background-color: transparent;
  text-align: left;
  padding: 6px;
  width: 100%;
  border: none;
  font-size: 1.1rem;
  font-weight: bold;
  color:white;
}
.control-container-feature-group-arrow {
  border: solid white;
  border-width: 0 3px 3px 0;
  position: relative;
  float: right;
  padding: 3px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg)
}
.control-container-feature-group-collapsible-active, .control-container-feature-group-collapsible:hover {
  background-color: rgba(100, 133, 172, 1);
}
/* ************************************************************************** */
/* ******************** Mode Controls *************************************** */
/* ************************************************************************** */

.mode-control-container {
  position: absolute;
  bottom: 50px;
  right: 4px;
  z-index: 1000;
}

.mode-control-items {
  position: relative;
  background: #233845;
  padding-left: 10px;
  padding-right: 10px;
  text-align:center;
  border-radius: 10px;
}

.mode-control-item {
  display: inline-block;
  color: white;
  height: 25px;
  width: 40px;
  cursor: pointer;
}

.mode-control-item.select {
  background: rgb(50, 80, 99);
}

/* ************************************************************************** */
/* ******************** Legend  ********************************************* */
/* ************************************************************************** */

.map-legend-container {
  position: absolute;
  bottom: 20px;
  right: 8px;
  z-index: 1000;
  color: #233845;
  font-size: 12px;
  font-weight: 700;
  width: 310px;
}

.map-legend-items {
  background: #233845;
  padding-right: 10px;
  text-align: center;
  border-radius: 10px;
  display: flex
}

.map-legend-label {
  width: 50px;
  color: #fff;
}

.map-legend-item {
  width: 50px
}

/* ************************************************************************** */
/* ******************** Weather Map Legend  ********************************* */
/* ************************************************************************** */

.weather-map-legend-container {
  position: absolute;
  bottom: 45px;
  right: 8px;
  z-index: 1000;
  color: #233845;
  font-size: 12px;
  font-weight: 700;
  width: 310px;
}

.weather-map-legend-items {
  background: #233845;
  padding-right: 10px;
  text-align: center;
  border-radius: 10px;
  display: flex;
  width: 310px;
}

.weather-map-legend-label {
  width: 50px;
  color: #fff;
}

.weather-map-legend-item-container {
  display: flex;
  width: 260px;
}

.weather-map-legend-item {
  flex: 0 100%;
  color: white;
}

/* ************************************************************************** */
/* ******************** Animation Controls  ********************************* */
/* ************************************************************************** */

.animation-controls-container {
  position: absolute;
  top: calc(100% - 60px);
  left: 8px;
  z-index: 1000;
  width: calc(100% - 350px);
  transition: .4s top cubic-bezier(0.0,0.0,0.2,1);
}

.panel-open .animation-controls-container {
  top: calc(62% - 60px);
}

.animation-controls-play {
  position: relative;
  width: 36px;
  height: 36px;
  font-size: 10px;;
  color: white;
  background-color: #233845;
  cursor: pointer;
  border-radius: 50%;
  transition: background-color 3s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;
}

/* Should grow */
.animation-controls-bar {
  position: absolute;
  left: 41px;
  bottom: 14px;
  width: calc(100% - 40px);
  height: 8px;
  background-color: #233845;
  border-radius: 10px;
  cursor: pointer;
}

.animation-controls-bar-played {
  position: absolute;
  background-color: rgb(70, 102, 138);
  height: 100%;
  width: 25%;
  transition-duration: 0.2s;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.animation-controls-labels {
  position: absolute;
  left: 42px;
  bottom: 0;
  display: flex;
  width: calc(100% - 40px);
  align-items: center;
  line-height: 1;
  text-shadow: 0px 0px 3px black;
}

.animation-controls-label {
  border-right: 1px solid #6f7a81;
  color: white;
  font-weight: bold;
  flex: 1;
  font-size: 12px;
  text-align: center;
  line-height: 1;
  height: 12px;
}

.animation-controls-label:last-child {
  border-right: none
}

.animation-controls-current-position {
  position: absolute;
  bottom: 10px;
  right: -10px;
  margin-left: -10px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid rgb(70, 102, 138);
  transition-duration: 0.2s;
  cursor: grab;
}

.animation-controls-current-position-panel {
  position: absolute;
  border-radius: 10px;
  padding-left: 10px;
  padding-top: 2px;
  padding-right: 10px;
  padding-bottom: 2px;
  bottom: 8px;
  height: 24px;
  width: 180px;
  margin-left: -50px;
  color: white;
  background-color: rgb(70, 102, 138);
  font-size: 12px;
  transition-duration: 0.2s;
  cursor: grab;
  user-select: none;
  text-align: center;
}

/* ************************************************************************** */
/* ******************** Hazard Visualizer  ********************************** */
/* ************************************************************************** */

.rd-hazard-visualizer {
  display: flex;
  height: calc(100vh - 37px);
  border-top: 1px solid var(--grey3)
}

.rd-hazard-visualizer__title {
  padding: 1.5rem 1.5rem 0 1.5rem
}

.rd-hazard-visualizer__header {
  font-size: 16px;
  border-bottom: 1px solid #ddd;
  color: #598987;
  padding: .25rem 1rem;
  font-weight: 700;
}

.rd-hazard-visualizer__region-navigation {
  flex-shrink: 0;
  width: 175px;
  border-right: 1px solid var(--grey3);
}

.rd-hazard-visualizer__chart-container {
  display: flex;
  width: 100%;
  height: calc(100vh - 55px);
  background-color: white;
  margin: auto;
  text-align: center;
}

.rd-hazard-visualizer__chart-component {
  width: 100%;
  height: 100%;
  position: relative;
}

.rd-hazard-visualizer__line-chart-container {
  width: 100%;
  height: 100%;
  position: relative;
}

.rd-hazard-visualizer__chart-component span {
  font-size: 1.2rem;
}

.rd-hazard-visualizer__hazard-navigation {
  border-left: 1px solid var(--grey3);
  flex-shrink: 0;
  width: 175px;
}

.rd-hazard-visualizer__parameter-tab {
  position: relative;
  bottom: 0px;
}

.rd-hazard-visualizer__column {
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 1;
  width: 100%;
}

.rd-hazard-visualizer__data-header {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ddd;
  cursor: pointer;
  user-select: none;
  padding: .5rem 1rem;
}

.rd-hazard-visualizer__data-header > * + * {
  margin-left: .5rem
}

.rd-hazard-visualizer__data-header.open {
  background-color: #598987;
  color: white;
}

.rd-hazard-visualizer__data-row {
  border-bottom: 1px solid #ddd;
  user-select: none;
  cursor: pointer;
  padding: .5rem 1rem
}

.rd-hazard-visualizer__data-row.open {
  background-color: #2dbdb6;
  color: white;
}

.rd-hazard-visualizer__row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}

.rd-hazard-visualizer__no-chart {
  margin: auto;
  width: 320px;
  padding: 2rem;
  background-color: var(--wood-teal-light);
  text-align: center;
  position: relative;
  top: 3rem;
}
/* hacky override - need to speak to Adam about leaflet options */
.leaflet-top .leaflet-control {
  margin-top: 53px;
}


.leaflet-pane > svg path.leaflet-interactive:hover {
  fill: rgba(255,255,255,0.3)
}

.line-chart-d3-cls {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 25px;
  background: white;
}

/* ************************************************************************** */
/* ******************** Loading spinner ************************************* */
/* ************************************************************************** */

.loading-spinner {
  text-align: center;
  height: 107px;
  width: 320px;
  margin: auto;
  position: relative;
  top: 65px;
  font-weight: 700;
}

.loading-spinner__text {
  margin-bottom: 2rem;
}

/* overrides the styled from the vue component */
.loading-spinner .spinner {
  margin-top: 0;
  margin-bottom: 0;
}

.cube1[data-v-12edc234],
.cube2[data-v-12edc234] {
  background-color: var(--wood-teal);
}

/* ************************************************************************** */
/* ******************** Utility classes ************************************* */
/* ************************************************************************** */

.flex-row {
  display: flex;
  align-items: center;
}

.flex-row--end {
  display: flex;
  align-items: flex-end;
}

.flex-row > * + * {
  margin-left: .5rem
}

.u-float-right {
  float: right
}

/* ************************************************************************** */
/* ******************** Site Panel ****************************************** */
/* ************************************************************************** */

.site-panel {
  position: absolute;
  margin-top: 20px;
  bottom: 0;
  left: 0;
  right: 0;
  max-width: 100%;
  width: fit-content;
  max-height: 90vh;
  z-index: 1000;
  transition: .4s top cubic-bezier(0.0,0.0,0.2,1);
  display: flex;
  flex-shrink: 2;
}


.site-panel__toggle {
  cursor: pointer;
  background-color: #fff;
  width: 70px;
  height: 20px;
  position: absolute;
  top: -19px;
  left: calc(50% - 35px);
  border-top: 1px solid var(--grey2);
  border-left: 1px solid var(--grey2);
  border-right: 1px solid var(--grey2);
  z-index: -100;
  box-shadow: 0 1px 5px rgba(0,0,0,0.65);
  display: flex;
  padding: 3px .5rem 0 .5rem;
  justify-content: space-between;
}

.site-panel__icon {
  fill: var(--wood-grey);
  color: var(--wood-grey);
}

.site-panel__icon.active {
  fill: var(--wood-teal);
  color: var(--wood-teal);
}

.panel-open .icon-rotate {
  transform: rotate(180deg);
  top: 0
}

.site-panel__toggle::before {
  content: '';
  display: block;
  position: absolute;
  bottom: -8px;
  left: -5px;
  height: 8px;
  background-color: #fff;
  right: -5px;
}

.site-panel__content {
  background-color: #fff;
  border-top: 1px solid var(--grey2);
  width: fit-content;
  max-width: 100vw;
  box-shadow: 0 1px 5px rgba(0,0,0,0.65);
  padding: 0.5rem;
  overflow-y: auto;
}

body::-webkit-scrollbar-track,
.site-panel__content::-webkit-scrollbar-track,
.timelines__scrollpane::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  border-radius: 6px;
  background-color: #F5F5F5;
}

body::-webkit-scrollbar,
.site-panel__content::-webkit-scrollbar,
.timelines__scrollpane::-webkit-scrollbar {
  width: 6px;
  background-color: #F5F5F5;
}

body::-webkit-scrollbar-thumb,
.site-panel__content::-webkit-scrollbar-thumb,
.timelines__scrollpane::-webkit-scrollbar-thumb {
  background-color: var(--grey3);
}

/* timeline content when it is placed in the sidepanlel*/
.site-panel .timelines__scrollpane {
  overflow-x: auto;
  width: calc(100vw - 2rem - 178px);
}

.site-panel .rd-table__risk-info {
  height: 34px;
  padding-right: 6px;
}

.site-panel .rd-table__risk-cell {
  height: 34px;
  border-radius: 17px;
}

.site-panel .rd-table__risk-number {
  line-height: 24px;
  font-size: 1rem;
  width: 24px;
  height: 24px;
}

.site-panel .timelines__timeline-row {
  height: 34px
}

.site-panel .timeline__unit {
  height: 21px;
}

.site-panel .timelines__hazard-cell {
  margin-bottom: 0;
  padding-top: 0
}

.site-panel .rd-table {
  font-size: .8rem;
}

/* Overwrite some vue-form-wizard styles */
.vue-form-wizard .wizard-nav-pills > li > a {
  color: rgb(48, 42, 42)!important;
}

.stepTitle{
  color: rgb(48, 42, 42)!important;
}

.swal-text {
 color: rgba(0,0,0,.84)!important;
}

.tabcontent {
  border-bottom: none!important;
}
.tabs {
  min-height: 0px!important;
}
.vue-form-wizard {
  padding-bottom: 20px;
  background: rgb(211 39 55 / 5%)!important;
}
.vue-form-wizard label[for]{
  cursor:pointer;
}
.swal-button {
  background-color: var(--wood-teal)!important;
}
.swal-button--danger {
  background-color: #e64942!important;
}
.swal-button--cancel {
  color: #555;
  background-color: #efefef!important;
}
.left-15 {
  padding-left: 15%
}
.wizard-header {
  display: none!important;
}
.row-clean {
  display: flex;
  flex-direction: row;
}
.wizard-tab-content {
  padding: 10px 20px 10px!important;
}
.wizard-parameter-tab {
  display: flex;
  justify-content: flex-start;
}
.wizard-parameter-item {
  padding:8px;
  width:25%;
}
.wizard-parameter-add-container {
  padding-top:24px;
}
.wizard-parameter-container {
  display:flex;
  flex-direction: column;
}
.wizard-parameter-content {
  display: flex;
  flex-direction: row;
}
.wizard-parameter-select {
  float: left;
}
.wizard-parameter-remove-btn {
  vertical-align: middle;
  display:inline-block;
  margin: 6px
}
.wizard-parameter-table, .wizard-review-detail-table {
  border-collapse: collapse;
  box-shadow: #CCC 2px 2px 5px;
}
.wizard-parameter-table tr:last-child td, .wizard-review-detail-table tr:last-child td {
  border:none;
}
.wizard-parameter-table thead {
  background-color: var(--wood-teal);
  color:#fff;
}
.wizard-parameter-table thead th {
  padding:8px;
}
.wizard-parameter-table tr td {
  padding:8px;
  text-align: center;
}
.wizard-parameter-table tr td:first-child {
  text-align: right;
}
.wizard-parameter-table tbody td {
  border-bottom: 1px solid var(--grey4);
}
.wizard-review-detail-table tr td {
  padding:8px;
  text-align: center;
  border-bottom: 1px solid var(--grey4);
}
.wizard-review-detail-table tr td:first-child {
  background-color: var(--wood-teal);
  color: #fff;
  text-align: right;
  border-bottom: none;
}
 .wizard-review-container {
   display:flex;
   flex-direction: row;
   justify-content: space-evenly;
   padding: 32px;
 }
.wizard-hr {
  border:none;
  border-bottom: 1px solid var(--grey4);
}
.wg-form-control {
  background-color:white!important;
}
.pull-left {
  display: inline-block;
}
.left-80 {
  padding-left: 80%;
}
.left-65 {
  padding-left: 65%;
}
.left-15 {
  padding-left: 15%;
}
.left-45 {
  padding-left: 45%;
}
.w-25 {
  width: 25%;
}
.short-text {
  white-space: nowrap!important;
  text-overflow: ellipsis!important;
  overflow: hidden!important;
  font-size:14px!important;
  font-weight: bold!important;;
}
/******************************************************/
/******************* Feature Panel ********************/
/******************************************************/
.wg-feature-table-container{
  display:flex;
  flex-direction: column;
  justify-content: space-evenly;

}
.wg-feature-table-container-item{
  text-align: center;
}
.wg-feature-table-inner-container{
  display: flex;
  flex-direction: row;

}
.wg-flex-container{
  display: flex;
  flex-direction: column;
  width: fit-content;
  max-width: 50vw;
  height:100%;
}
.wg-feature-table-header{
  overflow: hidden;
  background-color: var(--wood-teal);
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  color:white;
}
.wg-feature-table {
  border-collapse: collapse;
}
.wg-feature-table td {
  padding: 5px 12px;
  min-width: 100px;
  max-width: 50%;
  text-align: left;
}
.wg-feature-table > tbody td:first-child {
  text-align: left;
  white-space: nowrap;
  background-color: var(--wood-grey);
  color:white;

}
.wg-flex-header{
  text-align: center;
}
.leaflet-touch .leaflet-control-layers-toggle {
  width: 34px!important;
  height: 34px!important;
}
.slider-input {
  width: 50px!important;
  padding: 5px!important;
}
.slider-input-container{
  width: 350px!important;
  padding: 5px!important;
}
.slider-input-container label {
  display: block;
  margin-bottom: 2px;
  font-size: 12px;
}
.wg-range-slider {
  width: 100%;
  cursor: pointer;
  accent-color: #3498db;
}
.slider-container-row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center
}
.warning {
  border: solid 0.1px #d04435;
  text-align: center;
  color: #d04435;
  padding: 10px;
  width: 100%;
}

.feature-navigators {
  align-items: center;
  display: flex;
  flex-direction: row;
}

.feature-navigate-button {
  background-color: #f1f1f1;
  color: black;
  text-decoration: none;
  border-radius: 50%;
  display: inline-block;
  margin-right: 5px;
  margin-left: 5px;
  padding: 8px 16px;
}

.feature-navigate-button:hover {
  background-color: #ddd;
  color: black;
}

/******************************************************/
/******************* Cookie Banner ********************/
/******************************************************/

.cookieBanner {
  position: fixed;
  bottom: 40px;
  box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);
  background-color: var(--wood-grey);
  border-radius: 5px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 5px 12px;
  left: 25%;
  right: 25%;
  width: 50%;
  z-index: 1000;
}
.cookieBannerContent {
  flex-direction: column;
  display: flex;
  flex-grow: 1;
  flex-basis: 600px;
  padding: 10px;
}
.cookieBannerHeader {
  color: #ffffff;
}
.cookieBannerButtons {
  flex-direction: row;
  display: flex;
  margin: 16px 8px 8px;
}
.cookieBannerButton {
  padding: 0.5rem 1rem;
  margin: 5px;
  color: #ffffff;
  border: 1px solid #ffffff;
  font-size: medium;
  background-color: transparent;
  border-radius: 0;
}
.cookieBannerButton:hover {
  color: #ffffff;
  background-color: var(--wood-teal);
}

/******************************************************/
/******************* Policies Page ********************/
/******************************************************/

.policiesBody {
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  margin-top: 3%;
  margin-bottom: 12%;
}
.policiesHeader {
  display: block;
  font-weight: bold;
  margin-left: 1em;
}
.policiesHeaderH2 {
  display: block;
  font-weight: bold;
  margin-left: 1.2em;
}
.policiesHeaderH3 {
  display: block;
  font-weight: bold;
  margin-left: 1.8em;
}
.policiesParagraph {
  display: block;
  margin-left: 2em;
  margin-right: 1.2em;
  font-size: 1.2em;
}
.policiesGroup {
  margin-top: 50px;
}

/******************************************************/
/******************* Profile Page ********************/
/******************************************************/


.profileButton {
  color: #fff;
  background-color: #337ab7;
  border-color: #2e6da4;
  display: inline-block;
  margin-bottom: 0;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  background-image: none;
  border: 1px solid transparent;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  border-radius: 4px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.profileSettings {
  margin-top: 15px;
  margin-left: 15px;
}

.profileOptionsSelector:hover {
  background-color:#337ab7
}

/* start tabs */
.profileTabs {
  position: relative;
  clear: both;
  margin: 25px 0;
}
.profileTab {
  float: left;
}
.profileTabLabel {
  cursor: pointer;
  background: #eee;
  padding: 10px;
  border: 1px solid #ccc;
  margin-left: -1px;
  position: relative;
  left: 1px;
}
.profileTab [type=radio] {
  display: none;
}
.profileTabContent {
  position: absolute;
  top: 28px;
  left: 0;
  background: white;
  right: 0;
  bottom: 0;
  padding: 20px;
  border-top: 1px solid #ccc;
}

[type=radio]:checked ~ label ~ .profileTabContent {
  z-index: 1;
}

.validation-label {
  width: 250px; /* Seriously - this shouldn't be hard-coded */
  position: relative;
  background: white;
  height: 26px;
  border: 2px solid black;
  left: -15px;
  padding-left: 4px;
  padding-right: 4px;
  padding-top: 2px;
  padding-bottom: 2px;
}

.validation-label-pointer-outer {
  position: relative;
  bottom: 36px;
  left: 15px;
  width: 0; 
  height: 0; 
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid black;
}

.validation-label-pointer-inner {
  width: 0; 
  height: 0; 
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid white;
  position: relative;
  left: -10px;
  top: 2px;
}

/******************************************************/
/******************* Editor Page ********************/
/******************************************************/

.editor-modal-mask {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.editor-modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.editor-modal-container {
  width: fit-content;
  max-width: 95%;
  flex-wrap: wrap;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.editor-modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.editor-modal-body {
  margin: 20px 0;
}

.editor-modal-default-button {
  cursor: pointer;
  float: right;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 27px;
  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  color: #fff;
  border-radius: 27px;
  font-weight: 700;
  padding: .5rem 1.7rem;
}

.editor-modal-default-button:hover {
    opacity: .7;
    color: #fff
}

.editor-modal-default-button--grey {
    background-color: var(--wood-grey);
}

.editor-modal-default-button--teal {
    background-color: var(--wood-teal);
}

.editor-modal-enter {
  opacity: 0;
}

.editor-modal-leave-active {
  opacity: 0;
}

.editor-modal-enter .modal-container,
.editor-modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.editorTabs {
  position: relative;
  clear: both;
  margin: 25px 0;
}
.editorTab {
  float: left;
}
.editorTabLabel {
  cursor: pointer;
  background: #eee;
  padding: 10px;
  border: 1px solid #ccc;
  margin-left: -1px;
  position: relative;
  left: 1px;
}
.editorTab [type=radio] {
  display: none;
}
.editorTabContent {
  position: absolute;
  top: 28px;
  left: 0;
  background: white;
  right: 0;
  bottom: 0;
  padding: 20px;
  border-top: 1px solid #ccc;
}
[type=radio]:checked ~ label {
  background: white;
  border-bottom: 1px solid white;
  z-index: 1;
}
[type=radio]:checked ~ label ~ .editorTabContent {
  z-index: 1;
}


/******************************************************/
/******************* Region Panel ********************/
/******************************************************/

.rd-table__location-icon__active {
  color: blue;
}
.rd-table__filter-header {
  width: 50px;
  text-align: center
}
.rd-table__filter-cell {
  width: 50px;
  vertical-align: middle;
  font-weight: 700
}
.rd-table__filter-text {
  display: flex;
  justify-content: space-between;
}


/******************************************************/
/******************* User Menu Buttons ********************/
/******************************************************/


.user-dropbtn {
  color: white;
  padding: 2px 4px;
  font-size: 16px;
  border: none;
  z-index: 10000;
}

/* The container <div> - needed to position the dropdown content */
.user-dropdown {
  position: relative;
  display: inline-block;
}

/* Dropdown Content (Hidden by Default) */
.user-dropdown-content {
  display: none;
  position: absolute;
  background-color: #f1f1f1;
  min-width: 80px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 2000;
  right: 0px;
  top: 20px;
}

/* Links inside the dropdown */
.user-dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

/* Change color of dropdown links on hover */
.user-dropdown-content a:hover {background-color: #ddd;}

/* Show the dropdown menu on hover */
.user-dropdown:hover .user-dropdown-content {display: block;}

/* Change the background color of the dropdown button when the dropdown content is shown */
.user-dropdown:hover .user-dropbtn {}


/******************************************************/
/******************* Parameter Config ********************/
/******************************************************/


path.line {
  fill: none;
  stroke: #ecbc3a;
  stroke-width: 3px;
}

/*Some fancy animation to draw chart*/
svg .lineChart > path {
  background-color: #fff;
  stroke: #000;
  stroke-width: 3;
  stroke-dasharray: 4813.713;
  stroke-dashoffset: 4813.713;

  -webkit-animation-duration: 0s;
  animation-duration: 0s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-iteration-count: 1;
  animation-iteration-count: 1;
  -webkit-animation-timing-function: linear;
  animation-timing-function: linear;
  -webkit-animation-name: draw;
  animation-name: draw;
}

@-webkit-keyframes draw {
  100% { stroke-dashoffset: 0; }
}
@keyframes draw {
  100% {stroke-dashoffset: 0;}
}

/******************************************************/
/******************* D3 Chart ********************/
/******************************************************/

.chart-tooltip {
  position: absolute;
  z-index: 10;
  visibility: hidden;
  background-color: rgba(255, 255, 255, 0.8);
  text-align: center;
  padding: 4px;
  border-radius: 4px;
  color: black;
  font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
  font-size: 14px;
  font-style: normal;
}

.chart-data-root {
  display: flex;
}

.chart-data-root > .chart-data-line-chart {
  flex-flow: row wrap
}

.chart-data-line-chart {
  font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif;
  font-size: 14px;
  font-style: normal;
  position: relative;
  border-bottom: 2px solid black;
}

.chart-data-line-chart path.domain {
  stroke: black
}

.chart-data-line-chart .invalid-options {
  border: 1px solid red;
  padding: 1rem;
}

.chart-data-line-chart .overlay {
  fill: none;
  pointer-events: all;
}

.chart-data-line-chart .line {
  stroke-width: 2;
  fill: none;
}

.chart-data-line-chart .tick .line {
  stroke: black;
}

.chart-data-line-chart .axis .tick text {
  font-size: 14px;
  stroke: black;
  stroke-width: 0.2px;
}

.chart-data-line-chart .line-graph-label {
  font-size: 14px;
  fill: black;
}`, "",{"version":3,"sources":["webpack://./src/css/style.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;EAeE,2CAA2C;EAC3C,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;;EAEtB,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;;EAEpB,kBAAkB;EAClB,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;EAClC,0CAA0C;EAC1C,mCAAmC;EACnC,oCAAoC;;EAEpC,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;;EAEhB,cAAc;EACd,oBAAoB;;AAEtB;;AAEA;;;EAGE;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,qCAAqC;EACrC,cAAc;EACd;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb;AACF;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;EAChB;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC;AACF;;AAEA;;;;GAIG;;AAEH;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,UAAU;EACV;AACF;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kCAAkC;EAClC,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;EAC7B,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,aAAa;EACb,qEAAqE;AACvE;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kCAAkC;EAClC,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;EAC7B,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,aAAa;EACb,qEAAqE;AACvE;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA,uBAAuB;AACvB;EACE,cAAc;EACd,WAAW;EACX,kCAAkC;EAClC,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;EAC7B,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,aAAa;EACb,qEAAqE;AACvE;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,kCAAkC;EAClC,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;;;EAIE,aAAa;EACb,sBAAsB;AACxB;;AAEA,2BAA2B;;AAE3B;EACE,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,6BAA6B;EAC7B,YAAY;EACZ;AACF;;AAEA;;;EAGE,iBAAiB;EACjB;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,YAAY;EACZ;AACF;AACA;;;EAGE,mBAAmB;EACnB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iFAAiF;AACjF;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,iCAAiC;EACjC,4CAA4C;EAC5C,kEAAkE;EAClE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,uCAAuC;EACvC,eAAe;AACjB;;AAEA,yBAAyB;;AAEzB;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB;AACF;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC;AACF;;AAEA;EACE,mCAAmC;EACnC;AACF;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC;AACF;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;EACrC;AACF;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,iBAAiB;EACjB;AACF;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,aAAa;EACb,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,4BAA4B;EAC5B,YAAY;EACZ,gBAAgB;EAChB,kEAAkE;AACpE;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE;AACF;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,6BAA6B;EAC7B,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,8HAA8H;EAC9H,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,sCAAsC;EACtC,kEAAkE;AACpE;;AAEA;EACE,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;AACA,eAAe;;AAEf;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB,EAAE,0CAA0C;EAC7D,eAAe;EACf,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB;;AAEF;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,2CAA2C;EAC3C,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;;EAEtB,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;;EAEpB,kBAAkB;EAClB,oBAAoB;EACpB,6CAA6C;EAC7C,mCAAmC;EACnC,kCAAkC;EAClC,0CAA0C;EAC1C,mCAAmC;EACnC,oCAAoC;;EAEpC,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,4CAA4C;;EAE5C,8BAA8B;;EAE9B,cAAc;EACd,oBAAoB;AACtB;;AAEA;;;EAGE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,qCAAqC;EACrC,cAAc;EACd;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;AACA,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;AAC/E;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,YAAY;EACZ,cAAc;EACd,kCAAkC;EAClC,4CAA4C;EAC5C,kEAAkE;EAClE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;AACF;;AAEA,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;AAC/E;EACE,eAAe;EACf;AACF;;AAEA,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;AAC/E;EACE;AACF;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,yBAAyB,EAAE,+EAA+E;AAC5G;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,qBAAqB;EACrB;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,aAAa;EACb;AACF;;AAEA;EACE;;IAEE,cAAc;IACd;EACF;AACF;;AAEA,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;AAC/E;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;IACE,cAAc;IACd;EACF;AACF;;AAEA,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;AAC/E;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX;AACF;;AAEA;EACE,aAAa;EACb;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB;AACF;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC;AACF;;AAEA;EACE,mCAAmC;EACnC;AACF;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC;AACF;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;EACrC;AACF;;;AAGA;EACE;IACE,WAAW;IACX,cAAc;IACd,WAAW;IACX;EACF;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT;EACF;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,cAAc;EACd,aAAa;AACf;;AAEA,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;AAC/E;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd;AACF;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;AACA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;AACF;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,yCAAyC;EACzC;AACF;;AAEA;EACE,yCAAyC;EACzC;AACF;;AAEA;EACE,wCAAwC;EACxC;AACF;;AAEA;EACE,wCAAwC;EACxC,8DAA8D;EAC9D;AACF;;AAEA;EACE,uCAAuC;EACvC,8DAA8D;EAC9D;AACF;;AAEA;EACE,oCAAoC;EACpC;AACF;;AAEA;EACE,oCAAoC;EACpC;AACF;;AAEA;EACE,mCAAmC;EACnC;AACF;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC;AACF;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;EACrC;AACF;;AAEA;;;EAGE;AACF;;;AAGA;;EAEE;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;AACF;;AAEA;EACE;IACE,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB;EACF;;EAEA;IACE,6BAA6B;IAC7B,cAAc;IACd;EACF;;;EAGA;IACE,6BAA6B;IAC7B,aAAa;IACb;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,qBAAqB;IACrB;EACF;;EAEA;IACE,WAAW;IACX,oBAAoB;IACpB;EACF;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV;EACF;;EAEA;;;AAGF,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;AAC/E;EACE;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB;AACF;;AAEA,uCAAuC;AACvC;EACE,qCAAqC;AACvC;;AAEA;;EAEE;AACF;;AAEA,wCAAwC;AACxC;EACE,qCAAqC;AACvC;;AAEA;;EAEE;AACF;;AAEA,0CAA0C;AAC1C;EACE,qCAAqC;AACvC;;AAEA;;EAEE;AACF;;AAEA,yCAAyC;AACzC;EACE,qCAAqC;AACvC;;AAEA;;EAEE;AACF;;AAEA,yCAAyC;AACzC;EACE,qCAAqC;AACvC;;AAEA;;EAEE;AACF;;AAEA,wCAAwC;AACxC;EACE,qCAAqC;AACvC;;AAEA;;EAEE;AACF;;AAEA,0CAA0C;AAC1C;EACE,qCAAqC;AACvC;;AAEA;;EAEE;AACF;;AAEA,0CAA0C;AAC1C;EACE,qCAAqC;AACvC;;AAEA;;EAEE;AACF;;AAEA,yCAAyC;AACzC;EACE,qCAAqC;AACvC;;AAEA;;EAEE;AACF;;AAEA,wCAAwC;AACxC;EACE,sCAAsC;AACxC;;AAEA;;EAEE;AACF;;AAEA,2CAA2C;AAC3C;EACE,sCAAsC;AACxC;;AAEA;;EAEE;AACF;;AAEA,2CAA2C;AAC3C;EACE,sCAAsC;AACxC;;AAEA;;EAEE;AACF;;AAEA,6CAA6C;AAC7C;EACE,sCAAsC;AACxC;;AAEA;;EAEE;AACF;;AAEA,6CAA6C;AAC7C;EACE,sCAAsC;AACxC;;AAEA;;EAEE;AACF;;AAEA,4CAA4C;AAC5C;EACE,sCAAsC;AACxC;;AAEA;;EAEE;AACF;;AAEA,4CAA4C;AAC5C;EACE,sCAAsC;AACxC;;AAEA;;EAEE;AACF;;AAEA,8CAA8C;AAC9C;EACE,sCAAsC;AACxC;;AAEA;;EAEE;AACF;;AAEA,6CAA6C;AAC7C;EACE,sCAAsC;AACxC;;AAEA;;EAEE;AACF;;AAEA,6CAA6C;AAC7C;EACE,sCAAsC;AACxC;;AAEA;;EAEE;AACF;;AAEA,2CAA2C;AAC3C;EACE,sCAAsC;AACxC;;AAEA;;EAEE;AACF;;AAEA,+CAA+C;AAC/C;EACE,sCAAsC;AACxC;;AAEA;;EAEE;AACF;;AAEA,+CAA+C;AAC/C;EACE,sCAAsC;AACxC;;AAEA;;EAEE;AACF;;AAEA,iDAAiD;AACjD;EACE,sCAAsC;AACxC;;AAEA;;EAEE;AACF;;AAEA,iFAAiF;AACjF;EACE,wBAAwB;AAC1B;;AAEA;;EAEE;AACF;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB;AACF;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC;AACF;;AAEA;EACE,mCAAmC;EACnC;AACF;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE;IACE;EACF;;EAEA;IACE;EACF;;AAEF;;AAEA,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;AAC/E;EACE,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;AAC/E;EACE,aAAa;EACb;AACF;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB;AACF;;AAEA;EACE;AACF;;AAEA,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;AAC/E;EACE,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE;AACF;;AAEA,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;AAC/E;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;;AAGA,eAAe;AACf;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;;AAEd;;AAEA;;;;;;;;;;;CAWC;;AAED;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;;;EAKE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;;AAE/E;EACE;AACF;;AAEA,0CAA0C,+BAA+B;AACzE,0CAA0C,+BAA+B;AACzE,0CAA0C,+BAA+B;AACzE,0CAA0C,+BAA+B;AACzE,0CAA0C,+BAA+B;AACzE,0CAA0C,+BAA+B;AACzE,0CAA0C,+BAA+B;AACzE,0CAA0C,+BAA+B;AACzE,0CAA0C,+BAA+B;AACzE,2CAA2C,gCAAgC;AAC3E,2CAA2C,gCAAgC;AAC3E,2CAA2C,gCAAgC;AAC3E,2CAA2C,gCAAgC;AAC3E,2CAA2C,gCAAgC;AAC3E,2CAA2C,gCAAgC;AAC3E,2CAA2C,gCAAgC;AAC3E,2CAA2C,gCAAgC;AAC3E,2CAA2C,gCAAgC;AAC3E,2CAA2C,gCAAgC;AAC3E,2CAA2C,gCAAgC;AAC3E,2CAA2C,gCAAgC;AAC3E,2CAA2C,gCAAgC;AAC3E,2CAA2C,gCAAgC;AAC3E,2CAA2C,cAAc;;AAEzD,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;;AAE/E;EACE;AACF;;AAEA,0CAA0C,qCAAqC;AAC/E,0CAA0C,qCAAqC;AAC/E,0CAA0C,qCAAqC;AAC/E,0CAA0C,qCAAqC;AAC/E,0CAA0C,qCAAqC;AAC/E,0CAA0C,qCAAqC;AAC/E,0CAA0C,qCAAqC;AAC/E,0CAA0C,qCAAqC;AAC/E,0CAA0C,qCAAqC;AAC/E,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,wBAAwB;;;AAGnE,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;AAC/E;EACE;AACF;;AAEA,0CAA0C,qCAAqC;AAC/E,0CAA0C,qCAAqC;AAC/E,0CAA0C,qCAAqC;AAC/E,0CAA0C,qCAAqC;AAC/E,0CAA0C,qCAAqC;AAC/E,0CAA0C,qCAAqC;AAC/E,0CAA0C,qCAAqC;AAC/E,0CAA0C,qCAAqC;AAC/E,0CAA0C,qCAAqC;AAC/E,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,wBAAwB;;;AAGnE,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;AAC/E;EACE;AACF;;AAEA,0CAA0C,qCAAqC;AAC/E,0CAA0C,qCAAqC;AAC/E,0CAA0C,qCAAqC;AAC/E,0CAA0C,qCAAqC;AAC/E,0CAA0C,qCAAqC;AAC/E,0CAA0C,qCAAqC;AAC/E,0CAA0C,qCAAqC;AAC/E,0CAA0C,qCAAqC;AAC/E,0CAA0C,qCAAqC;AAC/E,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,wBAAwB;;;AAGnE,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;AAC/E;EACE;AACF;;AAEA,0CAA0C,qCAAqC;AAC/E,0CAA0C,qCAAqC;AAC/E,0CAA0C,qCAAqC;AAC/E,0CAA0C,qCAAqC;AAC/E,0CAA0C,qCAAqC;AAC/E,0CAA0C,qCAAqC;AAC/E,0CAA0C,qCAAqC;AAC/E,0CAA0C,qCAAqC;AAC/E,0CAA0C,qCAAqC;AAC/E,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,sCAAsC;AACjF,2CAA2C,wBAAwB;;AAEnE;EACE;IACE,aAAa;EACf;AACF;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB;;AAEF;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;;AAEA,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;;AAE/E;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,OAAO;AACT;;AAEA;EACE,OAAO;AACT;;AAEA;IACI,gBAAgB;AACpB;;AAEA;CACC;AACD;;AAEA,uBAAuB;AACvB;IACI,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA,oEAAoE;AACpE;IACI;AACJ;;AAEA;EACE,+CAA+C;EAC/C,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,6BAA6B;EAC7B,qBAAqB;AACvB;AACA,SAAS;;AAET;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,yBAAyB;EACzB,eAAe;AACjB;;AAEA,uBAAuB;;AAEvB;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,kEAAkE;AACpE;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;;;;;;;+EAO+E;;AAE/E,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;AAC/E;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,wDAAwD;EACxD,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,wBAAwB;EACxB,UAAU;EACV;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB;AACF;;AAEA;EACE,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,uBAAuB;EACvB;AACF;;AAEA;EACE,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB;AACF;;AAEA;EACE,SAAS;EACT,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB;AACF;;AAEA;EACE,QAAQ;EACR,OAAO;EACP,gBAAgB;EAChB,2BAA2B;EAC3B;AACF;;AAEA;EACE,QAAQ;EACR,QAAQ;EACR,gBAAgB;EAChB,2BAA2B;EAC3B;AACF;;AAEA;EACE,MAAM;EACN,SAAS;EACT,iBAAiB;EACjB,uBAAuB;EACvB;AACF;;AAEA;EACE,MAAM;EACN,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB;AACF;;AAEA;EACE,MAAM;EACN,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB;AACF;;AAEA,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;AAC/E;EACE,gBAAgB;EAChB;;AAEF;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,oBAAoB;EACpB,sBAAsB;EACtB,4BAA4B;EAC5B,oCAAoC;EACpC,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,aAAa;EACb,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B;;;;EAIA;EACA,gBAAgB;EAChB,gBAAgB;EAChB;;EAEA;EACA,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb;;EAEA;EACA,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,6BAA6B;EAC7B;;EAEA;EACA,mBAAmB;EACnB;;EAEA;EACA,oBAAoB;EACpB;;EAEA;EACA,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB;;AAEF;EACE;IACE,gBAAgB;IAChB,oBAAoB;EACtB;EACA;IACE,sCAAsC;EACxC;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;AAC/E;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,sBAAsB;EACtB,oCAAoC;EACpC,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,aAAa;EACb,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS;AACX;;AAEA,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;AAC/E;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,sCAAsC;EACtC,sCAAsC;EACtC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,8BAA8B;EAC9B,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,UAAU;EACV,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,UAAU;AACZ;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,oCAAoC;AACtC;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,UAAU;AACZ;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB;AACF;AACA;EACE,wCAAwC;AAC1C;AACA,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;;AAE/E;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;;AAE/E;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB;AACF;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE;AACF;;AAEA,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;;AAE/E;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;;AAE/E;EACE,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,2CAA2C;EAC3C,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,wBAAwB;EACxB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,aAAa;EACb,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,iBAAiB;EACjB,OAAO;EACP,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,oCAAoC;EACpC,wCAAwC;EACxC,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mCAAmC;EACnC,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;;AAE/E;EACE,aAAa;EACb,0BAA0B;EAC1B;AACF;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,0BAA0B;EAC1B,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,OAAO;EACP,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE;AACF;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf;AACF;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,wCAAwC;EACxC,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;AACX;AACA,iEAAiE;AACjE;EACE,gBAAgB;AAClB;;;AAGA;EACE;AACF;;AAEA;EACE,mDAAmD;EACnD,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;;AAE/E;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;;AAE/E;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;;AAE/E;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,+CAA+C;EAC/C,aAAa;EACb,cAAc;AAChB;;;AAGA;EACE,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,kCAAkC;EAClC,mCAAmC;EACnC,oCAAoC;EACpC,aAAa;EACb,sCAAsC;EACtC,aAAa;EACb,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;EACtC,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,iDAAiD;EACjD,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;;EAGE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;;;EAGE,8BAA8B;AAChC;;AAEA,wDAAwD;AACxD;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;CACC,gCAAgC;AACjC;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,yCAAyC;AAC3C;AACA;EACE,cAAc;AAChB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,mCAAmC;AACrC;AACA;EACE,WAAW;EACX,mCAAmC;AACrC;AACA;EACE;AACF;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,oBAAoB;EACpB;AACF;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,WAAW;AACb;AACA;EACE,kCAAkC;EAClC,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;AACvC;AACA;EACE,kCAAkC;EAClC,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;CACC;GACE,YAAY;GACZ,mBAAmB;GACnB,6BAA6B;GAC7B,aAAa;CACf;AACD;EACE,WAAW;EACX,qCAAqC;AACvC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,0BAA0B;EAC1B,wBAAwB;EACxB,2BAA2B;AAC7B;AACA,uDAAuD;AACvD,uDAAuD;AACvD,uDAAuD;AACvD;EACE,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;;AAE/B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;;AAErB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;EAClC,WAAW;;AAEb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;AACF;AACA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA,uDAAuD;AACvD,uDAAuD;AACvD,uDAAuD;;AAEvD;EACE,eAAe;EACf,YAAY;EACZ,0CAA0C;EAC1C,kCAAkC;EAClC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,8BAA8B;EAC9B,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,UAAU;EACV,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA,uDAAuD;AACvD,uDAAuD;AACvD,uDAAuD;;AAEvD;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD,sDAAsD;AACtD,uDAAuD;;;AAGvD;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,8BAA8B;EAC9B,0BAA0B;EAC1B,eAAe;EACf,sBAAsB;EACtB,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;AACF;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,iBAAiB;EACjB,QAAQ;EACR,SAAS;EACT,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY,EAAE,6CAA6C;EAC3D,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,+BAA+B;EAC/B,kBAAkB;EAClB,WAAW;EACX,QAAQ;AACV;;AAEA,uDAAuD;AACvD,qDAAqD;AACrD,uDAAuD;;AAEvD;EACE,eAAe;EACf,aAAa;EACb,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,6BAA6B;EAC7B,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,8HAA8H;EAC9H,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,iBAAiB;EACjB,QAAQ;EACR,SAAS;EACT,aAAa;EACb,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,UAAU;AACZ;AACA;EACE,UAAU;AACZ;;;AAGA,uDAAuD;AACvD,sDAAsD;AACtD,uDAAuD;;AAEvD;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX;AACF;AACA;EACE,WAAW;EACX,sBAAsB;EACtB;AACF;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;;;AAGA,uDAAuD;AACvD,2DAA2D;AAC3D,uDAAuD;;;AAGvD;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA,kEAAkE;AAClE;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,4CAA4C;EAC5C,aAAa;EACb,UAAU;EACV,SAAS;AACX;;AAEA,8BAA8B;AAC9B;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,4CAA4C;AAC5C,gCAAgC,sBAAsB,CAAC;;AAEvD,oCAAoC;AACpC,6CAA6C,cAAc,CAAC;;AAE5D,0FAA0F;AAC1F,oCAAoC;;;AAGpC,uDAAuD;AACvD,0DAA0D;AAC1D,uDAAuD;;;AAGvD;EACE,UAAU;EACV,eAAe;EACf,iBAAiB;AACnB;;AAEA,qCAAqC;AACrC;EACE,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,2BAA2B;;EAE3B,8BAA8B;EAC9B,sBAAsB;EACtB,qCAAqC;EACrC,6BAA6B;EAC7B,oCAAoC;EACpC,4BAA4B;EAC5B,yCAAyC;EACzC,iCAAiC;EACjC,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,OAAO,oBAAoB,EAAE;AAC/B;AACA;EACE,MAAM,oBAAoB,CAAC;AAC7B;;AAEA,uDAAuD;AACvD,kDAAkD;AAClD,uDAAuD;;AAEvD;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,wDAAwD;EACxD,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;AACF;;AAEA;EACE,wDAAwD;EACxD,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE;AACF;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb","sourcesContent":["(decisionvue-mockups)\n/*******************************************************************************\n  For styles which apply to the Risk Dashboard.\n\n  Classes prefixed with rd- are for components that are used in\n  the risk dashboard only.\n\n  Author: Beck Davies\n  Date: March 12th, 2019\n\n*******************************************************************************/\n\n/* start mockup decisionvue.css (used for the login page) */\n\n:root {\n  /* Colours which apply to the risk levels */\n  --level01: 95, 60%, 62%;\n  --level02: 62, 85%, 70%;\n  --level03: 42, 98%, 65%;\n  --level04: 15, 84%, 59%;\n  --level05: 1, 69%, 49%;\n\n  /* Varying opacities */\n  --opacity-standard: 0.8;\n  --opacity-muted: 0.4;\n\n  /* Brand colours */\n  --wood-grey: #233845;\n  --wood-green: rgba(136, 197, 64, 1);\n  --wood-teal: rgba(45, 189, 182, 1);\n  --wood-teal-light: rgba(45, 189, 182, 0.1);\n  --wood-teal-dark: rgb(89, 137, 135);\n  --wood-purple: rgba(136, 76, 145, 1);\n\n  --grey1: #f3f3f3;\n  --grey2: #ced4da;\n  --grey3: #adbcbb;\n  --grey4: #849faf;\n\n  --red: #d04435;\n  --light-red: #f9e8e6;\n\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box\n}\n\n@font-face {\n  font-family: 'Montserrat';\n  src: local('Montserrat'), url('../assets/fonts/Montserrat-Regular.ttf')  format('truetype')\n}\n\nhtml {\n  font-size: 14px\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  line-height: 1.6;\n  font-size: 1rem;\n  font-family: 'Montserrat', sans-serif;\n  color: #233845;\n  background-color: #fff\n}\n\nimg {\n  width: 100%;\n}\n\nlabel {\n  font-weight: 700;\n  color: var(--grey4)\n}\n\na {\n  color: var(--wood-teal)\n}\n\n.hc-content {\n  display: flex;\n  align-items: flex-start\n}\n\n.hc-content__menu {\n  width: 250px;\n  height: calc(100vh - 91px);\n  overflow-y: auto;\n  border-right: 1px solid var(--border-color)\n}\n\n.hc-content__config {\n  flex-grow: 1;\n  padding: 1.5rem;\n}\n\n.flex-row {\n  display: flex;\n  align-items: center;\n}\n\n.flex-row > * + * {\n  margin-left: .5rem\n}\n\n.flex-row--align-top {\n  align-items: flex-start;\n}\n\n.flex-row--align-end {\n  align-items: flex-end;\n}\n\n.flex-row--space-between {\n  justify-content: space-between;\n}\n\n.flex-row--margin + .flex-row--margin {\n  margin-top: 1rem\n}\n\n.preferences-indent {\n  margin-left: 20px;\n}\n\n.hc-location-details {\n  margin-top: 1rem;\n}\n\n.hc-hazard {\n  padding: 1rem;\n  margin-bottom: 1rem;\n  border-left: 0px solid var(--wood-teal);\n  border-bottom: 2px solid var(--wood-teal)\n}\n\n/* .hc-hazard:nth-child(even) {\n\n  background: var(--grey1);\n\n} */\n\n.hc-parameter {\n  display: flex;\n}\n\n.hc-component {\n  display: inline-block;\n  align-items: center;\n  margin-top: .25rem\n}\n\n.hc-component > * + * {\n  margin-left: .5rem\n}\n\n.hazard-disabled {\n  opacity: 0.6;\n}\n\n.hazard-enabled {\n  opacity: 1;\n}\n\n.hc-actions {\n  margin-left: auto;\n  white-space: nowrap;\n}\n\n.hc-heading {\n  display: flex;\n  align-items: flex-end;\n  border-bottom: 1px solid var(--grey3);\n  font-size: 1.25rem;\n  font-weight: bold;\n  padding-bottom: 0.75rem;\n  line-height: 1;\n  color: var(--wood-teal);\n  margin-bottom: .5rem;\n}\n\n.hc-heading__text {\n  margin: 0;\n}\n\n.hc-heading--page {\n  padding: 1rem 1rem 0.75rem 1rem;\n  margin-bottom: 0;\n}\n\n.hc-block + .hc-block {\n  margin-top: 3rem;\n}\n\n.region {\n  background-color: var(--wood-teal-dark);\n  color: #fff;\n}\n\n.slider {\n  width: 50%;\n  margin: 1rem 0\n}\n\n.slider__range {\n  width: calc(100% - 50px)\n}\n\n.slider__number {\n  width: 50px;\n  margin-left: 1rem\n}\n\n.wg-form-control {\n  display: block;\n  width: 100%;\n  height: calc(1.5em + .75rem + 2px);\n  padding: .25rem .5rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  background-clip: padding-box;\n  background-color: transparent;\n  border-bottom: 1px solid var(--grey2);\n  border-left: 0;\n  border-right: 0;\n  border-top: 0;\n  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n}\n\n.wg-form-control--alerts {\n  display: block;\n  width: 150px;\n  height: calc(1.5em + .75rem + 2px);\n  padding: .25rem .5rem;\n  margin-bottom: 10px;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  background-clip: padding-box;\n  background-color: transparent;\n  border-bottom: 1px solid var(--grey2);\n  border-left: 0;\n  border-right: 0;\n  border-top: 0;\n  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n}\n\n.wg-form-control--white {\n  background-color: #fff;\n}\n\n.wg-form-control--sm {\n  width: 50px\n}\n\n.wg-form-control--auto {\n  width: auto;\n}\n\n.wg-form-control.hc-has-error,\nselect.hc-has-error {\n  border-bottom: 1px solid var(--red);\n  background-color: var(--light-red);\n}\n\n.wg-form-control:active,\n.wg-form-control:focus,\nselect:active,\nselect:focus,\ninput[type=text]:active,\ninput[type=text]:focus {\n  outline: none;\n}\n\n/* login form control */\n.lg-form-control {\n  display: block;\n  width: 100%;\n  height: calc(1.5em + .75rem + 2px);\n  padding: .25rem .5rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  background-clip: padding-box;\n  background-color: transparent;\n  border-bottom: 1px solid var(--grey2);\n  border-left: 0;\n  border-right: 0;\n  border-top: 0;\n  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n}\n\n.lg-button {\n  background-color: transparent;\n  text-align: 'center';\n  color: #fff;\n  cursor: pointer;\n  margin: 0 auto;\n  outline: none;\n  padding: 0.6rem 2.3rem;\n  border: 2px solid var(--wood-teal);\n  font-weight: bold;\n  font-size: 15px;\n}\n\n.lg-form-group {\n  margin-bottom: 1rem;\n}\n\n.lg-btn {\n  display: inline-block;\n  font-weight: 400;\n  color:#ffffff;\n  text-align: center;\n  vertical-align: middle;\n  cursor: pointer;\n}\n\n.lg-button:hover {\n  background-color: var(--wood-teal);\n}\n\n.lg-form-control--white {\n  background-color: #fff;\n}\n\n.lg-form-control--sm {\n  width: 50px\n}\n\n.lg-form-control--auto {\n  width: auto;\n}\n\n.lg-form-control.hc-has-error,\nselect.hc-has-error {\n  border-bottom: 1px solid var(--red);\n  background-color: var(--light-red);\n}\n\n.lg-form-control:active,\n.lg-form-control:focus,\ninput[type=text]:active,\ninput[type=text]:focus {\n  outline: none;\n  background-color: #fff;\n}\n\n/* end login form control */\n\n.hc-btn {\n  cursor: pointer;\n  color: var(--wood-teal);\n  font-size: 1rem;\n  background-color: transparent;\n  border: none;\n  padding: 0 .5rem\n}\n\n.hc-btn:hover,\n.hc-btn:active,\n.hc-btn:focus {\n  color: var(--red);\n  outline: none\n}\n\n.hc-btn--small {\n  font-size: .75rem;\n}\n\n.hc-btn--grey {\n  color: var(--wood-grey);\n}\n\n.hc-btn-offlimits {\n  cursor: pointer;\n  color: var(--grey4);\n  font-size: 1rem;\n  background-color: transparent;\n  border: none;\n  padding: 0 .5rem\n}\n.hc-btn-offlimits:hover,\n.hc-btn-offlimits:active,\n.hc-btn-offlimits:focus {\n  color: var(--grey4);\n  outline: none\n}\n\n.hc-nav-link {\n  padding: .5rem 1rem\n}\n\n.hc-nav-link.active {\n  background-color: var(--wood-teal);\n  color: white;\n}\n\n.modal-xlg {\n  max-width: 80%;\n}\n\n.wg-modal-body {\n  padding: 2rem\n}\n\n.hc-grip {\n  cursor: move;\n  float: left;\n  margin-right: .5rem;\n  color: var(--grey4);\n}\n\n.hc-text {\n  margin: 1rem 0;\n}\n\n.u-nowrap {\n  white-space: nowrap;\n}\n\n/** already appears in style.css, but just put here for the sake of the mockup **/\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: .5rem 1rem;\n  color: #fff;\n  line-height: 1;\n  background: rgba(35, 56, 69, 0.6);\n  border-bottom: 1px solid rgba(35, 56, 69, 0);\n  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);\n  font-size: 1rem;\n}\n\n.cell {\n  display: flex;\n}\n\n.dot {\n  display: block;\n  height: 16px;\n  width: 16px;\n  background-color: transparent;\n  border-radius: 50%;\n  border: 2px solid var(--wood-grey);\n}\n\n.dot.active {\n  background-color: var(--wood-teal);\n  border-color: var(--wood-grey);\n}\n\n.dot.visited {\n  background-color: #fff;\n}\n\n.dot.visited:hover,\n.dot.active:hover {\n  background-color: var(--wood-teal-dark);\n  cursor: pointer;\n}\n\n/*copied from styles.css*/\n\n.key__item {\n  width: 2rem;\n  height: 2rem;\n  line-height: 2rem;\n  text-align: center;\n  font-weight: 700\n}\n\n.key__item--lev01 {\n  background-color: rgb(148, 216, 100);\n  background-color: hsl(var(--level01));\n}\n\n.key__item--lev02 {\n  background-color: rgb(239, 244, 113);\n  background-color: hsl(var(--level02))\n}\n\n.key__item--lev03 {\n  background-color: rgb(253, 201, 78);\n  background-color: hsl(var(--level03))\n}\n\n.key__item--lev04 {\n  background-color: rgb(238, 107, 63);\n  background-color: hsl(var(--level04));\n  color: white\n}\n\n.key__item--lev05 {\n  background-color: rgb(211, 42, 39);\n  background-color: hsl(var(--level05));\n  color: white\n}\n\n.hc-message {\n  border-left-width: 2px;\n  border-left-style: solid;\n  margin-top: .5rem;\n  padding: .5rem 1rem\n}\n\n.hc-message--error {\n  background-color: var(--light-red);\n  fill: var(--red);\n  color: var(--red);\n  border-left-color: var(--red);\n}\n\n.dropdown-toggle {\n  font-size: 14px;\n}\n\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  display: none;\n  float: left;\n  min-width: 10rem;\n  padding: .5rem 0;\n  margin: 8px 0 0;\n  font-size: 1rem;\n  color: #fff;\n  text-align: left;\n  list-style: none;\n  background-color: #7B888F;\n  background-clip: padding-box;\n  border: none;\n  border-radius: 0;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);\n}\n\n.dropdown-item {\n  padding: .5rem 1rem;\n  color: #fff;\n}\n\n.user-name {\n  padding-left: .5rem\n}\n\n.wg-btn {\n  display: inline-block;\n  text-align: center;\n  vertical-align: middle;\n  user-select: none;\n  background-color: transparent;\n  border: 1px solid transparent;\n  font-size: 1rem;\n  line-height: 1.5;\n  border-radius: 27px;\n  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n  color: #fff;\n  border-radius: 27px;\n  font-weight: 700;\n  padding: .5rem 1.7rem;\n}\n\n.wg-btn:hover {\n  opacity: .7;\n  color: #fff\n}\n\n.wg-btn--grey {\n  background-color: var(--wood-grey);\n}\n\n.wg-btn--teal {\n  background-color: var(--wood-teal);\n}\n\n.dv-background {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-size: cover;\n  z-index: -1;\n}\n\n.dv-login {\n  width: 300px;\n  margin: calc(50vh - 147px) auto 0 auto;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);\n}\n\n.dv-login__logo {\n  margin: 0 auto 3.5rem auto;\n  width: 70%;\n}\n\n.dv-login__body {\n  padding: 2rem;\n}\n\n.dv-login__body--dark {\n  background-color: var(--wood-grey);\n  color: #fff;\n}\n\n.dv-login__body--light {\n  background-color: #fff;\n  color: var(--wood-grey)\n}\n\n.dv-login__loading--spinner {\n  align-items: center;\n  margin-top: 0;\n  margin-bottom: 0;\n  text-align: center;\n}\n\n.dv-login-error-msg {\n  color: red;\n}\n\n.wg-form__switch {\n  display: block;\n  height: 34px;\n  position: relative;\n  width: 60px;\n  margin-bottom: 0;\n}\n\n.wg-form__switch input {\n  display: none;\n}\n\n.wg-form__switch-slider {\n  background-color: #ccc;\n  bottom: 0;\n  cursor: pointer;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  transition: .4s;\n  border-radius: 34px;\n}\n\n.wg-form__switch-slider:before {\n  background-color: #fff;\n  bottom: 4px;\n  content: \"\";\n  height: 26px;\n  left: 4px;\n  position: absolute;\n  transition: .4s;\n  width: 26px;\n  border-radius: 50%;\n}\n\ninput:checked + .wg-form__switch-slider {\n  background-color: #5DDB3D;\n}\n\ninput:checked + .wg-form__switch-slider:before {\n  transform: translateX(26px);\n}\n\n.hc-table td {\n  padding: 0 1.5rem 1rem 0\n}\n\n.dropdown-user {\n  margin-left: 1.5rem\n}\n\n.u-width-265 {\n  width: 265px !important\n}\n/* end mockup */\n\n.accordion {\n  background-color: #fff;\n  color: #444;\n  cursor: pointer;\n  padding: 8px;\n  width: 120%;\n  border: none;\n  text-align: left;\n  outline: none;\n  /* font-size: 15px; */\n  transition: 0.4s;\n  display: block;\n}\n\n.accordion:after {\n  content: '\\02795'; /* Unicode character for \"plus\" sign (+) */\n  font-size: 16px;\n  color: #777;\n  float: left;\n  margin-right: 5px;\n  }\n\n.active, .accordion:hover {\n  background-color: #eee;\n}\n\n.panel {\n  /* padding: 0 18px; */\n  display: none;\n  background-color: white;\n  width: 120%;\n  overflow: hidden;\n}\n\nbody {\n  background-color: #ccc;\n}\n\n:root {\n\n  /* Colours which apply to the risk levels */\n  --level01: 95, 60%, 62%;\n  --level02: 62, 85%, 70%;\n  --level03: 42, 98%, 65%;\n  --level04: 15, 84%, 59%;\n  --level05: 1, 69%, 49%;\n\n  /* Varying opacities */\n  --opacity-standard: 0.8;\n  --opacity-muted: 0.4;\n\n  /* Brand colours */\n  --wood-grey: #233845;\n  --wood-grey-translucent: rgba(35, 56, 69, .9);\n  --wood-green: rgba(136, 197, 64, 1);\n  --wood-teal: rgba(45, 189, 182, 1);\n  --wood-teal-light: rgba(45, 189, 182, 0.1);\n  --wood-teal-dark: rgb(89, 137, 135);\n  --wood-purple: rgba(136, 76, 145, 1);\n\n  --grey1: #f3f3f3;\n  --grey2: #ced4da;\n  --grey3: #adbcbb;\n  --grey4: #849faf;\n  --grey5: #E7EBEC;\n  --grey5-translucent: rgba(231, 235, 236, .8);\n\n  --notification-yellow: #ecd21b;\n\n  --red: #d04435;\n  --light-red: #f9e8e6;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box\n}\n\nhtml {\n  font-size: 14px\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  line-height: 1.6;\n  font-size: 1rem;\n  font-family: 'Montserrat', sans-serif;\n  color: #233845;\n  background-color: #fff\n}\n\nhr {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  border-color: #777\n}\n\na {\n  color: var(--wood-teal)\n}\n/* ************************************************************************** */\n/* header at the top of the page **********************************************/\n/* ************************************************************************** */\n.header {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  padding: .75rem 1rem;\n  color: white;\n  line-height: 1;\n  background-color: var(--wood-grey);\n  border-bottom: 1px solid rgba(35, 56, 69, 0);\n  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);\n  font-size: 1rem;\n}\n\n.header--overlaid {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 1000;\n  background-color: var(--wood-grey-translucent);\n}\n\n.header__logo {\n  height: 20px;\n  width: auto;\n}\n\n.header__logo-clickable {\n  cursor: pointer;\n}\n\n.header__text {\n  line-height: 11px;\n  margin-top: 10px;\n}\n\n.header__logout {\n  float: right\n}\n\n/* ************************************************************************** */\n/* content - all content that is not in a header or a footer **************** */\n/* ************************************************************************** */\n.content {\n  padding: 0.5rem;\n  flex: 1\n}\n\n/* ************************************************************************** */\n/* message-banner  ********************************************************** */\n/* ************************************************************************** */\n.message-banner {\n  display: flex\n}\n\n.message-banner__message {\n  padding: 1rem 2.5rem;\n  flex: 1 1 0;\n  font-size: 14px;\n  text-decoration: none;\n  flex-basis: calc(100% /3); /* this is only needed becuase IE11 doesn't support some elements of flex box */\n}\n\n.message-banner__message--warning {\n  background-color: #F30202;\n  color: white\n}\n\n.message-banner__message--watch {\n  background-color: #fece7c;\n  color: #233845\n}\n\n.message-banner__message--advisory {\n  background-color: #83837f;\n  color: white\n}\n\n.message-banner__message--clear {\n  background-color:#eee;\n  color: #233845\n}\n\n.message-banner__text {\n  display: block;\n  font-weight: 700\n}\n\n.message-banner__date {\n  display: block;\n  font-size: 14px\n}\n\n.message-banner__text-wrap {\n  display: flex;\n  justify-content: space-between\n}\n\n@media screen and (max-width: 1024px) {\n  .message-banner,\n  .message-banner__message {\n    display: block;\n    width: 100%\n  }\n}\n\n/* ************************************************************************** */\n/* table-info - contains information above the table  *********************** */\n/* ************************************************************************** */\n.table-info {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 1rem 0;\n}\n\n.table-info--padded {\n  padding-left: 1.5rem\n}\n\n.table-heading {\n  font-size: 24px\n}\n\n@media screen and (max-width: 700px) {\n  .table-info {\n    display: block;\n    margin-bottom: 0\n  }\n}\n\n/* ************************************************************************** */\n/* key   ******************************************************************** */\n/* ************************************************************************** */\n.key {\n  width: auto;\n  padding: 0 1rem;\n  background-color:#eee;\n  border-radius: 25px;\n  display: flex;\n  align-items: center;\n}\n\n.key__activity {\n  background-color:#eee;\n}\n\n.key__title {\n  margin-right: 1rem;\n  padding-right: 1rem;\n  color: #777;\n  border-right: 1px solid var(--grey3)\n}\n\n.key__keys {\n  display: flex;\n  align-items: center\n}\n\n.key__items {\n  display: flex;\n  align-items: center;\n  margin: 0 1rem\n}\n\n.key__item {\n  width: 2rem;\n  height: 2rem;\n  line-height: 2rem;\n  text-align: center;\n  font-weight: 700\n}\n\n.key__item--lev01 {\n  background-color: rgb(148, 216, 100);\n  background-color: hsl(var(--level01));\n}\n\n.key__item--lev02 {\n  background-color: rgb(239, 244, 113);\n  background-color: hsl(var(--level02))\n}\n\n.key__item--lev03 {\n  background-color: rgb(253, 201, 78);\n  background-color: hsl(var(--level03))\n}\n\n.key__item--lev04 {\n  background-color: rgb(238, 107, 63);\n  background-color: hsl(var(--level04));\n  color: white\n}\n\n.key__item--lev05 {\n  background-color: rgb(211, 42, 39);\n  background-color: hsl(var(--level05));\n  color: white\n}\n\n\n@media screen and (max-width: 700px) {\n  .key {\n    width: 100%;\n    display: block;\n    float: none;\n    margin-top: 1rem\n  }\n\n  .key__title {\n    margin: 0 0 1rem 0;\n    padding-right: 0;\n    border: 0;\n    text-align: center\n  }\n\n  .key__keys {\n    width: 231px;\n    margin: auto;\n  }\n}\n\n.fixed_header tbody{\n  display:block;\n  overflow: auto;\n  height: 100px;\n}\n\n/* ************************************************************************** */\n/* the risk table  ********************************************************** */\n/* ************************************************************************** */\n.rd-table {\n  width: 100%;\n  table-layout: fixed;\n  font-size: 1rem;\n}\n\n.rd-table td,\n.rd-table th {\n  padding: .5rem;\n  border-bottom: 1px solid rgba(224, 224, 224, 1)\n}\n\n.rd-table td:first-child,\n.rd-table th:first-child {\n  padding-left: 0;\n}\n\n.rd-table td:last-child,\n.rd-table th:last-child {\n  padding-right: 0;\n}\n\n.rd-table__location-cell {\n  width: 200px;\n  vertical-align: middle;\n  font-weight: 700\n}\n\n.rd-table__location-text {\n  display: flex;\n  justify-content: space-between;\n}\n\n.rd-table__location-text > * + * {\n  margin-left: 1rem\n}\n\n.rd-table__icons-wrap {\n  width: 16px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n}\n\n.rd-table__icons-wrap > * + * {\n  margin-top: 1rem\n}\n\n.rd-table__location-icon {\n  cursor: pointer;\n  color: var(--grey3)\n}\n\n.rd-table__location-icon.active {\n  color: var(--notification-yellow)\n}\n\n.rd-table__location-header {\n  text-align: left\n}\n.rd-table__date-header {\n  text-align: center\n}\n\n.rd-table__hazard-header {\n  width: 185px\n}\n\n.rd-table__obs-header {\n  width: 210px;\n}\n.rd-table__risk-cell {\n  border-radius: 27px;\n  height: 54px\n}\n\n.rd-corner__risk-cell {\n  border-radius: 30px;\n  height: 100%;\n  padding: 3px 3px 3px 10px;\n}\n\n.rd-table__obs-cell {\n  text-align: center;\n}\n\n.rd-table__obs-name {\n  font-size: 12px;\n}\n\n.rd-table__obs-value {\n  font-weight: 700;\n  line-height: 1;\n}\n\n.rd-table__obs-time {\n  font-size: 12px;\n}\n\n.rd-table__icon-cell {\n  width: 50px\n}\n.rd-table__risk-info {\n  height: 54px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 9px 0 14px;\n  width: 100%;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.rd-table__risk-text {\n  flex: 1;\n  font-weight: 700;\n  margin-right: 4px;\n}\n\n.rd-table__risk-number {\n  text-align: center;\n  line-height: 36px;\n  font-size: 1.25rem;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  font-weight: 700;\n  flex-shrink: 0\n}\n\n.rd-table__risk-activity {\n  text-align: left;\n  line-height: 36px;\n  font-size: 1.75rem;\n  width: 36px;\n  border-radius: 50%;\n  font-weight: 700;\n}\n\n.rd-table__risk-info:hover {\n  text-decoration: none\n}\n\n.rd-table__image {\n  max-width: 100%\n}\n\n.rd-table__risk-cell--lev01 {\n  background-color: rgba(148, 216, 100, .4);\n  background-color: hsla(var(--level01),var(--opacity-muted))\n}\n\n.rd-table__risk-cell--lev02 {\n  background-color: rgba(239, 244, 113, .4);\n  background-color: hsla(var(--level02),var(--opacity-muted))\n}\n\n.rd-table__risk-cell--lev03 {\n  background-color: rgba(253, 201, 78, .8);\n  background-color: hsla(var(--level03),var(--opacity-standard))\n}\n\n.rd-table__risk-cell--lev04 {\n  background-color: rgba(238, 107, 63, .8);\n  background-color: hsla(var(--level04),var(--opacity-standard));\n  color: white\n}\n\n.rd-table__risk-cell--lev05 {\n  background-color: rgba(211, 42, 39, .8);\n  background-color: hsla(var(--level05),var(--opacity-standard));\n  color: white\n}\n\n.rd-table__risk-cell--lev01 .rd-table__risk-number {\n  background-color: rgb(148, 216, 100);\n  background-color: hsl(var(--level01))\n}\n\n.rd-table__risk-cell--lev02 .rd-table__risk-number {\n  background-color: rgb(239, 244, 113);\n  background-color: hsl(var(--level02))\n}\n\n.rd-table__risk-cell--lev03 .rd-table__risk-number {\n  background-color: rgb(253, 201, 78);\n  background-color: hsl(var(--level03))\n}\n\n.rd-table__risk-cell--lev04 .rd-table__risk-number {\n  background-color: rgb(238, 107, 63);\n  background-color: hsl(var(--level04));\n  color: white\n}\n\n.rd-table__risk-cell--lev05 .rd-table__risk-number {\n  background-color: rgb(211, 42, 39);\n  background-color: hsl(var(--level05));\n  color: white\n}\n\n.rd-table__risk-cell--lev01 .rd-table__risk-info,\n.rd-table__risk-cell--lev02 .rd-table__risk-info,\n.rd-table__risk-cell--lev03 .rd-table__risk-info {\n  color: #233845\n}\n\n\n.rd-table__risk-cell--lev04 .rd-table__risk-info,\n.rd-table__risk-cell--lev05 .rd-table__risk-info {\n  color: white\n}\n\n.rd-table__icon {\n  width: 24px;\n  height: 24px;\n  display: block\n}\n\n@media screen and (max-width: 1024px) {\n  .rd-table thead {\n    border: none;\n    clip: rect(0 0 0 0);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    width: 1px\n  }\n\n  .rd-table tr {\n    border-bottom: 3px solid #ddd;\n    display: block;\n    margin-bottom: 2rem\n  }\n\n\n  .rd-table td {\n    border-bottom: 1px solid #ddd;\n    display: flex;\n    flex-wrap: wrap\n  }\n\n  .rd-table .rd-table__timeline-cell {\n    display: block\n  }\n\n  .rd-table td > * {\n    flex: 1 0 50%\n  }\n\n  .rd-table td::before {\n    content: attr(data-label);\n    font-weight: 700;\n    flex: 1 0 50%;\n    align-self: center;\n    padding-right: 1.5rem;\n    color: #233845\n  }\n\n  .rd-table .rd-table__timeline-cell::before {\n    width: 100%;\n    margin-bottom: .5rem;\n    display: block\n  }\n\n  .rd-table .rd-table__location-cell {\n    width: auto;\n    background-color: #ddd;\n    line-height: 1.5;\n  }\n\n  .rd-table__risk-cell {\n    width: 50%;\n    float: left\n  }\n\n  }\n\n\n/* ************************************************************************** */\n/* aggregated risk timeline component *************************************** */\n/* ************************************************************************** */\n.timeline {\n  display: flex\n}\n\n.timeline__block {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  border-left: 0.5px solid rgba(224, 224, 224, 1)\n}\n\n/* if a day has one block of readings */\n.timeline__block--1block {\n  flex: 0 0 calc((100% / 5) * (1 / 24));\n}\n\n.timeline__block--1block .timeline__label--1hr,\n.timeline__block--1block .timeline__unit--1hr {\n  flex: 0 0 calc(100% / 1)\n}\n\n/* if a day has two blocks of readings */\n.timeline__block--2block {\n  flex: 0 0 calc((100% / 5) * (2 / 24));\n}\n\n.timeline__block--2block .timeline__label--1hr,\n.timeline__block--2block .timeline__unit--1hr {\n  flex: 0 0 calc(100% / 2)\n}\n\n/* if a day has three blocks of readings */\n.timeline__block--3block {\n  flex: 0 0 calc((100% / 5) * (3 / 24));\n}\n\n.timeline__block--3block .timeline__label--1hr,\n.timeline__block--3block .timeline__unit--1hr {\n  flex: 0 0 calc(100% / 3)\n}\n\n/* if a day has four blocks of readings */\n.timeline__block--4block {\n  flex: 0 0 calc((100% / 5) * (4 / 24));\n}\n\n.timeline__block--4block .timeline__label--1hr,\n.timeline__block--4block .timeline__unit--1hr {\n  flex: 0 0 calc(100% / 4)\n}\n\n/* if a day has five blocks of readings */\n.timeline__block--5block {\n  flex: 0 0 calc((100% / 5) * (5 / 24));\n}\n\n.timeline__block--5block .timeline__label--1hr,\n.timeline__block--5block .timeline__unit--1hr {\n  flex: 0 0 calc(100% / 5)\n}\n\n/* if a day has six blocks of readings */\n.timeline__block--6block {\n  flex: 0 0 calc((100% / 5) * (6 / 24));\n}\n\n.timeline__block--6block .timeline__label--1hr,\n.timeline__block--6block .timeline__unit--1hr {\n  flex: 0 0 calc(100% / 6)\n}\n\n/* if a day has seven blocks of readings */\n.timeline__block--7block {\n  flex: 0 0 calc((100% / 5) * (7 / 24));\n}\n\n.timeline__block--7block .timeline__label--1hr,\n.timeline__block--7block .timeline__unit--1hr {\n  flex: 0 0 calc(100% / 7)\n}\n\n/* if a day has eight blocks of readings */\n.timeline__block--8block {\n  flex: 0 0 calc((100% / 5) * (8 / 24));\n}\n\n.timeline__block--8block .timeline__label--1hr,\n.timeline__block--8block .timeline__unit--1hr {\n  flex: 0 0 calc(100% / 8)\n}\n\n/* if a day has nine blocks of readings */\n.timeline__block--9block {\n  flex: 0 0 calc((100% / 5) * (9 / 24));\n}\n\n.timeline__block--9block .timeline__label--1hr,\n.timeline__block--9block .timeline__unit--1hr {\n  flex: 0 0 calc(100% / 9)\n}\n\n/* if a day has ten blocks of readings */\n.timeline__block--10block {\n  flex: 0 0 calc((100% / 5) * (10 / 24));\n}\n\n.timeline__block--10block .timeline__label--1hr,\n.timeline__block--10block .timeline__unit--1hr {\n  flex: 0 0 calc(100% / 10)\n}\n\n/* if a day has eleven blocks of readings */\n.timeline__block--11block {\n  flex: 0 0 calc((100% / 5) * (11 / 24));\n}\n\n.timeline__block--11block .timeline__label--1hr,\n.timeline__block--11block .timeline__unit--1hr {\n  flex: 0 0 calc(100% / 11)\n}\n\n/* if a day has twelve blocks of readings */\n.timeline__block--12block {\n  flex: 0 0 calc((100% / 5) * (12 / 24));\n}\n\n.timeline__block--12block .timeline__label--1hr,\n.timeline__block--12block .timeline__unit--1hr {\n  flex: 0 0 calc(100% / 12)\n}\n\n/* if a day has thirteen blocks of readings */\n.timeline__block--13block {\n  flex: 0 0 calc((100% / 5) * (13 / 24));\n}\n\n.timeline__block--13block .timeline__label--1hr,\n.timeline__block--13block .timeline__unit--1hr {\n  flex: 0 0 calc(100% / 13)\n}\n\n/* if a day has fourteen blocks of readings */\n.timeline__block--14block {\n  flex: 0 0 calc((100% / 5) * (14 / 24));\n}\n\n.timeline__block--14block .timeline__label--1hr,\n.timeline__block--14block .timeline__unit--1hr {\n  flex: 0 0 calc(100% / 14)\n}\n\n/* if a day has fifteen blocks of readings */\n.timeline__block--15block {\n  flex: 0 0 calc((100% / 5) * (15 / 24));\n}\n\n.timeline__block--15block .timeline__label--1hr,\n.timeline__block--15block .timeline__unit--1hr {\n  flex: 0 0 calc(100% / 15)\n}\n\n/* if a day has sixteen blocks of readings */\n.timeline__block--16block {\n  flex: 0 0 calc((100% / 5) * (16 / 24));\n}\n\n.timeline__block--16block .timeline__label--1hr,\n.timeline__block--16block .timeline__unit--1hr {\n  flex: 0 0 calc(100% / 16)\n}\n\n/* if a day has seventeen blocks of readings */\n.timeline__block--17block {\n  flex: 0 0 calc((100% / 5) * (17 / 24));\n}\n\n.timeline__block--17block .timeline__label--1hr,\n.timeline__block--17block .timeline__unit--1hr {\n  flex: 0 0 calc(100% / 17)\n}\n\n/* if a day has eighteen blocks of readings */\n.timeline__block-18block {\n  flex: 0 0 calc((100% / 5) * (18 / 24));\n}\n\n.timeline__block--18block .timeline__label--1hr,\n.timeline__block--18block .timeline__unit--1hr {\n  flex: 0 0 calc(100% / 18)\n}\n\n/* if a day has nineteen blocks of readings */\n.timeline__block--19block {\n  flex: 0 0 calc((100% / 5) * (19 / 24));\n}\n\n.timeline__block--19block .timeline__label--1hr,\n.timeline__block--19block .timeline__unit--1hr {\n  flex: 0 0 calc(100% / 19)\n}\n\n/* if a day has twenty blocks of readings */\n.timeline__block--20block {\n  flex: 0 0 calc((100% / 5) * (20 / 24));\n}\n\n.timeline__block--20block .timeline__label--1hr,\n.timeline__block--20block .timeline__unit--1hr {\n  flex: 0 0 calc(100% / 20)\n}\n\n/* if a day has twenty-one blocks of readings */\n.timeline__block--21block {\n  flex: 0 0 calc((100% / 5) * (21 / 24));\n}\n\n.timeline__block--21block .timeline__label--1hr,\n.timeline__block--21block .timeline__unit--1hr {\n  flex: 0 0 calc(100% / 21)\n}\n\n/* if a day has twenty-two blocks of readings */\n.timeline__block--22block {\n  flex: 0 0 calc((100% / 5) * (22 / 24));\n}\n\n.timeline__block--22block .timeline__label--1hr,\n.timeline__block--22block .timeline__unit--1hr {\n  flex: 0 0 calc(100% / 22)\n}\n\n/* if a day has twenty-three blocks of readings */\n.timeline__block--23block {\n  flex: 0 0 calc((100% / 5) * (23 / 24));\n}\n\n.timeline__block--23block .timeline__label--1hr,\n.timeline__block--23block .timeline__unit--1hr {\n  flex: 0 0 calc(100% / 23)\n}\n\n/* if a day has twenty-four blocks of readings - this is a full 24 hour period  */\n.timeline__block--24block {\n  flex: 0 0 calc(100% / 5);\n}\n\n.timeline__block--24block .timeline__label--1hr,\n.timeline__block--24block .timeline__unit--1hr {\n  flex-basis: calc(100% / 24)\n}\n\n.timeline__label--1hr:before {\n  content: attr(data-content);\n  display: block;\n  width: 13px;\n  height: 12px;\n  position: absolute;\n  z-index: 1;\n}\n\n.timeline__row {\n  display: flex;\n}\n\n.timeline__row--dates {\n  justify-content: center;\n  padding-bottom: .5rem\n}\n\n.timeline__row--labels {\n  text-align: left;\n  height: 12px;\n}\n\n.timeline__unit {\n  height: 32px;\n  position: relative;\n}\n\n.timeline__label {\n  font-size: 8px;\n  position: relative;\n}\n\n.timeline__label--1hr {\n  text-align: left;\n  padding-left: 1px\n}\n\n.timeline__label--1hr:not(:last-child) {\n  border-right: 1px solid rgba(224, 224, 224, 1);\n}\n\n.timeline__unit {\n  border-right: 1px solid white\n}\n\n.timeline__unit--lev00 {\n  background-color: rgb(230,230,230);\n}\n\n.timeline__unit--lev01 {\n  background-color: rgb(148, 216, 100);\n  background-color: hsl(var(--level01));\n}\n\n.timeline__unit--lev02 {\n  background-color: rgb(239, 244, 113);\n  background-color: hsl(var(--level02))\n}\n\n.timeline__unit--lev03 {\n  background-color: rgb(253, 201, 78);\n  background-color: hsl(var(--level03))\n}\n\n.timeline__unit--lev04 {\n  background-color: rgb(238, 107, 63);\n  background-color: hsl(var(--level04));\n}\n\n.timeline__unit--lev05 {\n  background-color: rgb(211, 42, 39);\n  background-color: hsl(var(--level05));\n}\n\n.timeline__unit--nolev {\n  background-color: rgb(255, 255, 255);\n}\n\n.timeline__unit--daynight {\n  background-color: rgb(210, 210, 210);\n}\n\n@media screen and (max-width: 767px) {\n\n  .timeline {\n    width: 767px\n  }\n\n  .timeline-wrapper {\n    overflow-x: auto\n  }\n\n}\n\n/* ************************************************************************** */\n/* text and icon component ************************************************** */\n/* ************************************************************************** */\n.text-and-icon {\n  display: flex;\n  text-decoration: none;\n  width: max-content;\n  color: inherit;\n  align-items: center;\n}\n\n.text-and-icon__mod {\n  text-decoration: none;\n  width: max-content;\n  color: inherit\n}\n\n.text-and-icon--small {\n  font-size: 12px\n}\n\n.text-and-icon--bold {\n  font-weight: 700;\n}\n\n.text-and-icon--grey {\n  color: #777\n}\n\n.text-and-icon--align-center {\n  align-items: center\n}\n\n.text-and-icon:not(:first-child) {\n  margin-top: .75rem\n}\n\n.text-and-icon__icon {\n  width: 16px;\n  height: 16px\n}\n\n.text-and-icon__text--right {\n  margin-left: .5rem\n}\n\n.text-and-icon__text--left {\n  margin-right: .5rem\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n/* ************************************************************************** */\n/* a list of links ********************************************************** */\n/* ************************************************************************** */\n.links {\n  display: flex;\n  background: #ccc\n}\n\n.links a {\n  padding: 1rem;\n  text-decoration: none;\n  color: inherit\n}\n\n.links .current {\n  background: #fff\n}\n\n/* ************************************************************************** */\n/* overriding bootstrap tooltips ******************************************** */\n/* ************************************************************************** */\n.tooltip {\n  font-size: 14px;\n  font-family: 'Montserrat';\n  position: fixed;\n}\n\n.tooltip.top {\n  margin-top: 0\n}\n\n.tooltip.right .tooltip-arrow {\n  border-right-color: #233845\n}\n\n.tooltip-inner {\n  background-color: #233845;\n  padding: .5rem 1rem\n}\n\n.tooltip.in {\n  opacity: 1\n}\n\n/* ************************************************************************** */\n/* overriding bootstrap modal *********************************************** */\n/* ************************************************************************** */\n.modal {\n  background: rgba(0, 0, 0, 0.5)\n}\n\n.modal-dialog {\n  max-width: 90%\n}\n\n.modal-content {\n  border-radius: 0\n}\n\n.modal-body__image {\n  max-width: 100%\n}\n\n.modal-header {\n  font-size: 1.5rem\n}\n\n.modal__button {\n  font-weight: 700\n}\n\n\n/**** NEW *****/\n.wg-page-wrapper {\n  display: flex;\n}\n\n.wg-column {\n  display: flex;\n  flex-direction: column;\n}\n\n.wg-row {\n  display: flex;\n  align-items: center;\n}\n\n.wg-row-header {\n  display: flex;\n  align-items: center;\n  height: 70px;\n}\n\n.wg-heading-cell--175 {\n  padding: 0.5rem;\n  font-weight: bold;\n  text-align: center;\n  width: 175px\n}\n\n.wg-table-cell--175 {\n  padding: 0.5rem;\n  width: 175px\n}\n\n.wg-heading-cell--200 {\n  padding: 0.5rem;\n  font-weight: bold;\n  text-align: center;\n  width: 175px\n}\n\n.wg-table-cell--200 {\n  padding: 0.5rem;\n  width: 200px\n}\n\n.wg-timelines-wrapper {\n  flex-grow: 1;\n}\n\n.wg-row--dates {\n  font-weight: 700;\n  text-align: center;\n  align-items: flex-end;\n  padding-bottom: 0.5rem;\n  height: 40px;\n}\n\n.wg-row--timeline {\n  height: 48px;\n}\n\n.wg-row--timeline-timezone {\n  text-align: center;\n  height: 30px;\n  \n}\n\n/*\n\nFORECAST DAYS STYLES\n====================\n\nfor forecasts of 5 days or less, make it use flexbox and occupy the full width\nof the screen. The widths of the timelines should be flexible\n\nfor forecasts of 6 days or more, set the widths of the timelines to be 300px -\nhardcode them. They will need to scroll\n\n*/\n\n.forecast .timeline__block {\n  flex: 0 0 300px;\n}\n\n.forecast .wg-scrollpane {\n  overflow-x: scroll;\n  padding: 0 .5rem;\n}\n\n.forecast--1day .wg-scrollpane,\n.forecast--2day .wg-scrollpane,\n.forecast--3day .wg-scrollpane,\n.forecast--4day .wg-scrollpane,\n.forecast--5day .wg-scrollpane {\n  overflow-x: auto;\n  padding: 0 .5rem;\n}\n\n/* ************************************************************************** */\n/* 1 day forecast *********************************************************** */\n/* ************************************************************************** */\n\n.forecast--1day .timeline {\n  width: 100%\n}\n\n.forecast--1day .timeline__block--1block {flex: 0 0 calc(100% * (1 / 24))}\n.forecast--1day .timeline__block--2block {flex: 0 0 calc(100% * (2 / 24))}\n.forecast--1day .timeline__block--3block {flex: 0 0 calc(100% * (3 / 24))}\n.forecast--1day .timeline__block--4block {flex: 0 0 calc(100% * (4 / 24))}\n.forecast--1day .timeline__block--5block {flex: 0 0 calc(100% * (5 / 24))}\n.forecast--1day .timeline__block--6block {flex: 0 0 calc(100% * (6 / 24))}\n.forecast--1day .timeline__block--7block {flex: 0 0 calc(100% * (7 / 24))}\n.forecast--1day .timeline__block--8block {flex: 0 0 calc(100% * (8 / 24))}\n.forecast--1day .timeline__block--9block {flex: 0 0 calc(100% * (9 / 24))}\n.forecast--1day .timeline__block--10block {flex: 0 0 calc(100% * (10 / 24))}\n.forecast--1day .timeline__block--11block {flex: 0 0 calc(100% * (11 / 24))}\n.forecast--1day .timeline__block--12block {flex: 0 0 calc(100% * (12 / 24))}\n.forecast--1day .timeline__block--13block {flex: 0 0 calc(100% * (13 / 24))}\n.forecast--1day .timeline__block--14block {flex: 0 0 calc(100% * (14 / 24))}\n.forecast--1day .timeline__block--15block {flex: 0 0 calc(100% * (15 / 24))}\n.forecast--1day .timeline__block--16block {flex: 0 0 calc(100% * (16 / 24))}\n.forecast--1day .timeline__block--17block {flex: 0 0 calc(100% * (17 / 24))}\n.forecast--1day .timeline__block--18block {flex: 0 0 calc(100% * (18 / 24))}\n.forecast--1day .timeline__block--19block {flex: 0 0 calc(100% * (19 / 24))}\n.forecast--1day .timeline__block--20block {flex: 0 0 calc(100% * (20 / 24))}\n.forecast--1day .timeline__block--21block {flex: 0 0 calc(100% * (21 / 24))}\n.forecast--1day .timeline__block--22block {flex: 0 0 calc(100% * (22 / 24))}\n.forecast--1day .timeline__block--23block {flex: 0 0 calc(100% * (23 / 24))}\n.forecast--1day .timeline__block--24block {flex: 0 0 100%}\n\n/* ************************************************************************** */\n/* 2 day forecast *********************************************************** */\n/* ************************************************************************** */\n\n.forecast--2day .timeline {\n  width: 100%\n}\n\n.forecast--2day .timeline__block--1block {flex: 0 0 calc((100% / 2) * (1 / 24))}\n.forecast--2day .timeline__block--2block {flex: 0 0 calc((100% / 2) * (2 / 24))}\n.forecast--2day .timeline__block--3block {flex: 0 0 calc((100% / 2) * (3 / 24))}\n.forecast--2day .timeline__block--4block {flex: 0 0 calc((100% / 2) * (4 / 24))}\n.forecast--2day .timeline__block--5block {flex: 0 0 calc((100% / 2) * (5 / 24))}\n.forecast--2day .timeline__block--6block {flex: 0 0 calc((100% / 2) * (6 / 24))}\n.forecast--2day .timeline__block--7block {flex: 0 0 calc((100% / 2) * (7 / 24))}\n.forecast--2day .timeline__block--8block {flex: 0 0 calc((100% / 2) * (8 / 24))}\n.forecast--2day .timeline__block--9block {flex: 0 0 calc((100% / 2) * (9 / 24))}\n.forecast--2day .timeline__block--10block {flex: 0 0 calc((100% / 2) * (10 / 24))}\n.forecast--2day .timeline__block--11block {flex: 0 0 calc((100% / 2) * (11 / 24))}\n.forecast--2day .timeline__block--12block {flex: 0 0 calc((100% / 2) * (12 / 24))}\n.forecast--2day .timeline__block--13block {flex: 0 0 calc((100% / 2) * (13 / 24))}\n.forecast--2day .timeline__block--14block {flex: 0 0 calc((100% / 2) * (14 / 24))}\n.forecast--2day .timeline__block--15block {flex: 0 0 calc((100% / 2) * (15 / 24))}\n.forecast--2day .timeline__block--16block {flex: 0 0 calc((100% / 2) * (16 / 24))}\n.forecast--2day .timeline__block--17block {flex: 0 0 calc((100% / 2) * (17 / 24))}\n.forecast--2day .timeline__block--18block {flex: 0 0 calc((100% / 2) * (18 / 24))}\n.forecast--2day .timeline__block--19block {flex: 0 0 calc((100% / 2) * (19 / 24))}\n.forecast--2day .timeline__block--20block {flex: 0 0 calc((100% / 2) * (20 / 24))}\n.forecast--2day .timeline__block--21block {flex: 0 0 calc((100% / 2) * (21 / 24))}\n.forecast--2day .timeline__block--22block {flex: 0 0 calc((100% / 2) * (22 / 24))}\n.forecast--2day .timeline__block--23block {flex: 0 0 calc((100% / 2) * (23 / 24))}\n.forecast--2day .timeline__block--24block {flex: 0 0 calc(100% / 2)}\n\n\n/* ************************************************************************** */\n/* 3 day forecast *********************************************************** */\n/* ************************************************************************** */\n.forecast--3day .timeline {\n  width: 100%\n}\n\n.forecast--3day .timeline__block--1block {flex: 0 0 calc((100% / 3) * (1 / 24))}\n.forecast--3day .timeline__block--2block {flex: 0 0 calc((100% / 3) * (2 / 24))}\n.forecast--3day .timeline__block--3block {flex: 0 0 calc((100% / 3) * (3 / 24))}\n.forecast--3day .timeline__block--4block {flex: 0 0 calc((100% / 3) * (4 / 24))}\n.forecast--3day .timeline__block--5block {flex: 0 0 calc((100% / 3) * (5 / 24))}\n.forecast--3day .timeline__block--6block {flex: 0 0 calc((100% / 3) * (6 / 24))}\n.forecast--3day .timeline__block--7block {flex: 0 0 calc((100% / 3) * (7 / 24))}\n.forecast--3day .timeline__block--8block {flex: 0 0 calc((100% / 3) * (8 / 24))}\n.forecast--3day .timeline__block--9block {flex: 0 0 calc((100% / 3) * (9 / 24))}\n.forecast--3day .timeline__block--10block {flex: 0 0 calc((100% / 3) * (10 / 24))}\n.forecast--3day .timeline__block--11block {flex: 0 0 calc((100% / 3) * (11 / 24))}\n.forecast--3day .timeline__block--12block {flex: 0 0 calc((100% / 3) * (12 / 24))}\n.forecast--3day .timeline__block--13block {flex: 0 0 calc((100% / 3) * (13 / 24))}\n.forecast--3day .timeline__block--14block {flex: 0 0 calc((100% / 3) * (14 / 24))}\n.forecast--3day .timeline__block--15block {flex: 0 0 calc((100% / 3) * (15 / 24))}\n.forecast--3day .timeline__block--16block {flex: 0 0 calc((100% / 3) * (16 / 24))}\n.forecast--3day .timeline__block--17block {flex: 0 0 calc((100% / 3) * (17 / 24))}\n.forecast--3day .timeline__block--18block {flex: 0 0 calc((100% / 3) * (18 / 24))}\n.forecast--3day .timeline__block--19block {flex: 0 0 calc((100% / 3) * (19 / 24))}\n.forecast--3day .timeline__block--20block {flex: 0 0 calc((100% / 3) * (20 / 24))}\n.forecast--3day .timeline__block--21block {flex: 0 0 calc((100% / 3) * (21 / 24))}\n.forecast--3day .timeline__block--22block {flex: 0 0 calc((100% / 3) * (22 / 24))}\n.forecast--3day .timeline__block--23block {flex: 0 0 calc((100% / 3) * (23 / 24))}\n.forecast--3day .timeline__block--24block {flex: 0 0 calc(100% / 3)}\n\n\n/* ************************************************************************** */\n/* 4 day forecast *********************************************************** */\n/* ************************************************************************** */\n.forecast--4day .timeline {\n  width: 100%\n}\n\n.forecast--4day .timeline__block--1block {flex: 0 0 calc((100% / 4) * (1 / 24))}\n.forecast--4day .timeline__block--2block {flex: 0 0 calc((100% / 4) * (2 / 24))}\n.forecast--4day .timeline__block--3block {flex: 0 0 calc((100% / 4) * (3 / 24))}\n.forecast--4day .timeline__block--4block {flex: 0 0 calc((100% / 4) * (4 / 24))}\n.forecast--4day .timeline__block--5block {flex: 0 0 calc((100% / 4) * (5 / 24))}\n.forecast--4day .timeline__block--6block {flex: 0 0 calc((100% / 4) * (6 / 24))}\n.forecast--4day .timeline__block--7block {flex: 0 0 calc((100% / 4) * (7 / 24))}\n.forecast--4day .timeline__block--8block {flex: 0 0 calc((100% / 4) * (8 / 24))}\n.forecast--4day .timeline__block--9block {flex: 0 0 calc((100% / 4) * (9 / 24))}\n.forecast--4day .timeline__block--10block {flex: 0 0 calc((100% / 4) * (10 / 24))}\n.forecast--4day .timeline__block--11block {flex: 0 0 calc((100% / 4) * (11 / 24))}\n.forecast--4day .timeline__block--12block {flex: 0 0 calc((100% / 4) * (12 / 24))}\n.forecast--4day .timeline__block--13block {flex: 0 0 calc((100% / 4) * (13 / 24))}\n.forecast--4day .timeline__block--14block {flex: 0 0 calc((100% / 4) * (14 / 24))}\n.forecast--4day .timeline__block--15block {flex: 0 0 calc((100% / 4) * (15 / 24))}\n.forecast--4day .timeline__block--16block {flex: 0 0 calc((100% / 4) * (16 / 24))}\n.forecast--4day .timeline__block--17block {flex: 0 0 calc((100% / 4) * (17 / 24))}\n.forecast--4day .timeline__block--18block {flex: 0 0 calc((100% / 4) * (18 / 24))}\n.forecast--4day .timeline__block--19block {flex: 0 0 calc((100% / 4) * (19 / 24))}\n.forecast--4day .timeline__block--20block {flex: 0 0 calc((100% / 4) * (20 / 24))}\n.forecast--4day .timeline__block--21block {flex: 0 0 calc((100% / 4) * (21 / 24))}\n.forecast--4day .timeline__block--22block {flex: 0 0 calc((100% / 4) * (22 / 24))}\n.forecast--4day .timeline__block--23block {flex: 0 0 calc((100% / 4) * (23 / 24))}\n.forecast--4day .timeline__block--24block {flex: 0 0 calc(100% / 4)}\n\n\n/* ************************************************************************** */\n/* 5 day forecast *********************************************************** */\n/* ************************************************************************** */\n.forecast--5day .timeline {\n  width: 100%\n}\n\n.forecast--5day .timeline__block--1block {flex: 0 0 calc((100% / 5) * (1 / 24))}\n.forecast--5day .timeline__block--2block {flex: 0 0 calc((100% / 5) * (2 / 24))}\n.forecast--5day .timeline__block--3block {flex: 0 0 calc((100% / 5) * (3 / 24))}\n.forecast--5day .timeline__block--4block {flex: 0 0 calc((100% / 5) * (4 / 24))}\n.forecast--5day .timeline__block--5block {flex: 0 0 calc((100% / 5) * (5 / 24))}\n.forecast--5day .timeline__block--6block {flex: 0 0 calc((100% / 5) * (6 / 24))}\n.forecast--5day .timeline__block--7block {flex: 0 0 calc((100% / 5) * (7 / 24))}\n.forecast--5day .timeline__block--8block {flex: 0 0 calc((100% / 5) * (8 / 24))}\n.forecast--5day .timeline__block--9block {flex: 0 0 calc((100% / 5) * (9 / 24))}\n.forecast--5day .timeline__block--10block {flex: 0 0 calc((100% / 5) * (10 / 24))}\n.forecast--5day .timeline__block--11block {flex: 0 0 calc((100% / 5) * (11 / 24))}\n.forecast--5day .timeline__block--12block {flex: 0 0 calc((100% / 5) * (12 / 24))}\n.forecast--5day .timeline__block--13block {flex: 0 0 calc((100% / 5) * (13 / 24))}\n.forecast--5day .timeline__block--14block {flex: 0 0 calc((100% / 5) * (14 / 24))}\n.forecast--5day .timeline__block--15block {flex: 0 0 calc((100% / 5) * (15 / 24))}\n.forecast--5day .timeline__block--16block {flex: 0 0 calc((100% / 5) * (16 / 24))}\n.forecast--5day .timeline__block--17block {flex: 0 0 calc((100% / 5) * (17 / 24))}\n.forecast--5day .timeline__block--18block {flex: 0 0 calc((100% / 5) * (18 / 24))}\n.forecast--5day .timeline__block--19block {flex: 0 0 calc((100% / 5) * (19 / 24))}\n.forecast--5day .timeline__block--20block {flex: 0 0 calc((100% / 5) * (20 / 24))}\n.forecast--5day .timeline__block--21block {flex: 0 0 calc((100% / 5) * (21 / 24))}\n.forecast--5day .timeline__block--22block {flex: 0 0 calc((100% / 5) * (22 / 24))}\n.forecast--5day .timeline__block--23block {flex: 0 0 calc((100% / 5) * (23 / 24))}\n.forecast--5day .timeline__block--24block {flex: 0 0 calc(100% / 5)}\n\n@media screen and (max-width: 1024px) {\n  .u-hidden-mobile {\n    display: none;\n  }\n}\n\n/* Graph Charts */\n.c3-line {\n  stroke-width: 2.5px;\n}\n\n.btn {\n  border: none;\n  background-color: inherit;\n  padding: 14px 28px;\n  font-size: 16px;\n  cursor: pointer;\n  display: inline-block;\n  }\n\n.btn:hover {\n  background: #eee;\n}\n\n.success {\n  color: green;\n}\n.info {\n  color: dodgerblue;\n}\n\n/* ************************************************************************** */\n/* ******************** Map and leaflet controls **************************** */\n/* ************************************************************************** */\n\n.map-page-container {\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.map-container {\n  position: relative;\n  display: flex;\n  flex: 5;\n}\n\n.map {\n  position: relative;\n  display: flex;\n  flex: 5;\n}\n\n.map > div {\n  flex: 1;\n}\n\n.leaflet-top .leaflet-control {\n    margin-top: 53px;\n}\n\n.leaflet-pane > svg path.leaflet-interactive:hover {\n\tfill: rgba(255,255,255,0.3)\n}\n\n/* Leaflet site icons */\n.leaflet-div-icon {\n    background: #fff;\n    border: 1px solid #666;\n}\n\n/* reduce the size of the leaflet attribution, for some more space */\n.leaflet-container .leaflet-control-attribution {\n    font-size: 9px\n}\n\n.leaflet-popup-content-wrapper {\n  background-color: rgba(0, 0, 0, 0.5) !important;\n  color: white !important;\n  font-size: 16px;\n}\n\n.leaflet-popup-tip {\n  height: 5px !important;\n  width: 5px !important;\n  font-family: palatino;\n  background-color: #bbb;\n  border-radius: 50% !important;\n  display: inline-block;\n}\n/* Cell */\n\n.cell {\n  display: flex;\n}\n\n.dot {\n  display: block;\n  height: 16px;\n  width: 16px;\n  background-color: transparent;\n  border-radius: 50%;\n  border: 2px solid var(--grey3);\n}\n\n.dot.active {\n  background-color: #2dbdb6;\n}\n\n.dot.visited {\n  background-color: white;\n}\n\n.dot.visited:hover,\n.dot.active:hover {\n  background-color: #598987;\n  cursor: pointer;\n}\n\n/* Leaflet site icons */\n\n.leaflet-div-icon {\n  background: #fff;\n  border: 1px solid #666;\n}\n\n.risk-icon-01 {\n  border-radius: 50%;\n  border: 5px solid rgb(148, 216, 100);\n  background-color: rgb(148, 216, 100);\n}\n\n.risk-icon-02 {\n  border-radius: 50%;\n  border: 5px solid rgb(239, 244, 113);\n  background-color: rgb(239, 244, 113);\n}\n\n.risk-icon-03 {\n  border-radius: 50%;\n  border: 5px solid rgb(253, 201, 78);\n  background-color: rgb(253, 201, 78);\n}\n\n.risk-icon-04 {\n  border-radius: 50%;\n  border: 5px solid rgb(238, 107, 63);\n  background-color: rgb(238, 107, 63);\n}\n\n.risk-icon-05 {\n  border-radius: 50%;\n  border: 5px solid rgb(211, 42, 39);\n  background-color: rgb(211, 42, 39);\n}\n\n.risk-detail-panel {\n  position: absolute;\n  top: 50px;\n  height: auto;\n  width: 315px;\n  background-color: white;\n  z-index: 2000;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);\n}\n\n.risk-detail-panel-left {\n  left: 40px;\n}\n\n.risk-detail-panel-right {\n  right: 50px;\n}\n\n.risk-detail-panel-header {\n  border-bottom: 1px solid rgb(128, 128, 128);\n  padding: .5rem 1rem;\n}\n\n.risk-detail-table {\n  margin: 1rem 1rem .5rem 1rem\n}\n\n.risk-detail-table-row {\n  display: flex;\n  align-items: center;\n  padding: .5rem;\n  border-top: 1px solid #ccc;\n}\n\n.risk-detail-table-heading {\n  font-size: 12px;\n  color: #598987;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  padding: 0 .5rem .25rem .5rem;\n}\n\n.risk-detail-table-row + .risk-detail-table-row {\n  margin-top: .25rem\n}\n\n.risk-detail-table-date {\n  min-width: 81px;\n  width: 81px;\n  margin-right: 1rem;\n}\n\n.risk-detail-hazard {\n  font-weight: 700;\n  padding: .25rem .75rem;\n  min-height: 30px;\n  border-radius: 15px;\n  width: 100%;\n}\n\n/*******************************************************************************\n  For styles have been copied from Bootstrap. I'm not including all of\n  bootstrap.css because it has some unwanted effects with inheritance etc.\n\n  Author: Beck Davies\n  Date: March 12th, 2019\n\n*******************************************************************************/\n\n/* ************************************************************************** */\n/* tooltips  **************************************************************** */\n/* ************************************************************************** */\n.tooltip {\n  position: absolute;\n  z-index: 1070;\n  display: block;\n  font-family: \"Helvetica Neue\",Helvetica,Arial,sans-serif;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.42857143;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  word-wrap: normal;\n  white-space: normal;\n  filter: alpha(opacity=0);\n  opacity: 0;\n  line-break: auto\n}\n\n.tooltip.in {\n  filter: alpha(opacity=90);\n  opacity: .9\n}\n\n.tooltip.top {\n  padding: 5px 0;\n  margin-top: -3px\n}\n\n.tooltip.right {\n  padding: 0 5px;\n  margin-left: 3px\n}\n\n.tooltip.bottom {\n  padding: 5px 0;\n  margin-top: 3px\n}\n\n.tooltip.left {\n  padding: 0 5px;\n  margin-left: -3px\n}\n\n.tooltip-inner {\n  max-width: 200px;\n  padding: 3px 8px;\n  color: #fff;\n  text-align: center;\n  background-color: #000;\n  border-radius: 4px\n}\n\n.tooltip-arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid\n}\n\n.tooltip.top .tooltip-arrow {\n  bottom: 0;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px 5px 0;\n  border-top-color: #000\n}\n\n.tooltip.top-left .tooltip-arrow {\n  right: 5px;\n  bottom: 0;\n  margin-bottom: -5px;\n  border-width: 5px 5px 0;\n  border-top-color: #000\n}\n\n.tooltip.top-right .tooltip-arrow {\n  bottom: 0;\n  left: 5px;\n  margin-bottom: -5px;\n  border-width: 5px 5px 0;\n  border-top-color: #000\n}\n\n.tooltip.right .tooltip-arrow {\n  top: 50%;\n  left: 0;\n  margin-top: -5px;\n  border-width: 5px 5px 5px 0;\n  border-right-color: #000\n}\n\n.tooltip.left .tooltip-arrow {\n  top: 50%;\n  right: 0;\n  margin-top: -5px;\n  border-width: 5px 0 5px 5px;\n  border-left-color: #000\n}\n\n.tooltip.bottom .tooltip-arrow {\n  top: 0;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 0 5px 5px;\n  border-bottom-color: #000\n}\n\n.tooltip.bottom-left .tooltip-arrow {\n  top: 0;\n  right: 5px;\n  margin-top: -5px;\n  border-width: 0 5px 5px;\n  border-bottom-color: #000\n}\n\n.tooltip.bottom-right .tooltip-arrow {\n  top: 0;\n  left: 5px;\n  margin-top: -5px;\n  border-width: 0 5px 5px;\n  border-bottom-color: #000\n}\n\n/* ************************************************************************** */\n/* modal   ****************************************************************** */\n/* ************************************************************************** */\n.modal-open {\n  overflow: hidden;\n  }\n\n.modal {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1050;\n  display: none;\n  overflow: hidden;\n  outline: 0;\n}\n\n.modal-open .modal {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: 0.5rem;\n  pointer-events: none;\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - (0.5rem * 2));\n}\n\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  pointer-events: auto;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 0.3rem;\n  outline: 0;\n}\n\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1040;\n  background-color: #000;\n}\n\n.modal-backdrop.fade {\n  opacity: 0;\n}\n\n\n.modal-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 1rem;\n  border-bottom: 1px solid #e9ecef;\n  border-top-left-radius: 0.3rem;\n  border-top-right-radius: 0.3rem;\n  }\n\n\n\n  .modal-title {\n  margin-bottom: 0;\n  line-height: 1.5;\n  }\n\n  .modal-body {\n  position: relative;\n  flex: 1 1 auto;\n  padding: 1rem;\n  }\n\n  .modal-footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 1rem;\n  border-top: 1px solid #e9ecef;\n  }\n\n  .modal-footer > :not(:first-child) {\n  margin-left: .25rem;\n  }\n\n  .modal-footer > :not(:last-child) {\n  margin-right: .25rem;\n  }\n\n  .modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n  }\n\n@media (min-width: 576px) {\n  .modal-dialog {\n    max-width: 500px;\n    margin: 1.75rem auto;\n  }\n  .modal-dialog-centered {\n    min-height: calc(100% - (1.75rem * 2));\n  }\n  .modal-sm {\n    max-width: 300px;\n  }\n}\n\n@media (min-width: 992px) {\n  .modal-lg {\n    max-width: 800px;\n  }\n}\n\n/* ************************************************************************** */\n/* ******************** Dropdowns ******************************************* */\n/* ************************************************************************** */\n.dropdown {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n}\n\n.dropdown-toggle::after {\n  display: inline-block;\n  margin-left: .255em;\n  vertical-align: .255em;\n  content: \"\";\n  border-top: .3em solid;\n  border-right: .3em solid transparent;\n  border-bottom: 0;\n  border-left: .3em solid transparent;\n}\n\n.dropdown-menu-right {\n  right: 0;\n  left: auto;\n}\n\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  display: none;\n  float: left;\n  min-width: 10rem;\n  padding: .5rem 0;\n  margin: 8px 0 0;\n  font-size: 1rem;\n  color: #fff;\n  text-align: left;\n  list-style: none;\n  background-color: #7B888F;\n  background-clip: padding-box;\n}\n\n.dropdown-header {\n  display: block;\n  padding: .5rem 1.5rem;\n  margin-bottom: 0;\n  font-size: .875rem;\n  color: #6c757d;\n  white-space: nowrap;\n}\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: .25rem 1.5rem;\n  clear: both;\n  font-weight: 400;\n  color: #212529;\n  text-align: inherit;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n}\n\n/* ************************************************************************** */\n/* ******************** Controls ******************************************** */\n/* ************************************************************************** */\n.controls-container {\n  position: absolute;\n  top: 10px;\n  right: 8px;\n  width: 40px;\n  z-index: 1000;\n}\n\n.control-container {\n  position: relative;\n  padding-bottom: 10px;\n}\n\n.control-container__button {\n  position: relative;\n  width: 40px;\n  height: 40px;\n  color: white;\n  background-color: #233845;\n  cursor: pointer;\n  border-radius: 50%;\n  transition: background-color 0.5s ease;\n  transition: background-color 0.5s ease;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  user-select: none;\n}\n\n.control-container__button.open {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  background-color: rgb(70, 102, 138);\n}\n\n.control-container__panel {\n  background-color: rgb(70, 102, 138);\n  top: 0px;\n  right: 40px;\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n  min-width: 35vh;\n  position: absolute;\n  max-height: 80vh;\n  overflow-y: auto;\n}\n\n.control-container__panel-inner {\n  padding: 8px;\n}\n\n.control-container__section {\n  color: white;\n}\n\n.control-container__section + .control-container__section {\n  margin-top: 1rem\n}\n\n.control-container__section-heading {\n  font-weight: bold\n}\n\n.control-container__item-row {\n  display: flex;\n  align-items: center;\n  padding-top: 5px;\n  padding-top: 5px;\n}\n\n.control-container__item-select {\n  flex-grow: 1;\n  margin-right: .5rem;\n  background: #233845;\n  color: white;\n  padding: .25rem;\n  border-color: #7d9199;\n}\n\n.control-container__item-select > option {\n  background: #233845;\n}\n.control-container__feature-group-list {\n  list-style-type:none;\n  padding:0px;\n  margin:0px;\n  margin-left:4px;\n}\n.control-container__feature-group-list input{\n  list-style-type:none;\n  padding:0px;\n  margin:0px;\n}\n.control-container__feature-group-item-label{\n  color:white;\n  cursor: pointer;\n}\n.control-container__feature-list {\n  list-style-type:none;\n  padding:3px;\n  margin:0px;\n  margin-left:5px;\n  overflow: hidden;\n  max-height: 0;\n  transition: max-height 0.2s ease-out;\n}\n.control-container__feature-list input{\n  list-style-type:none;\n  padding:0px;\n  margin:5px;\n}\n.control-container__feature-item-label{\n  color:white;\n  white-space: nowrap;\n  margin-bottom: 10px;\n  padding:10px;\n  cursor:pointer;\n}\n.control-container__feature-item-number-input {\n  background: #233845;\n  color: white;\n  padding: .25rem;\n  margin-left: 4px;\n  border-color: #7d9199;\n  width: 30%;\n}\n.control-container-feature-group-collapsible {\n  cursor: pointer;\n  background-color: transparent;\n  text-align: left;\n  padding: 6px;\n  width: 100%;\n  border: none;\n  font-size: 1.1rem;\n  font-weight: bold;\n  color:white;\n}\n.control-container-feature-group-arrow {\n  border: solid white;\n  border-width: 0 3px 3px 0;\n  position: relative;\n  float: right;\n  padding: 3px;\n  transform: rotate(45deg);\n  -webkit-transform: rotate(45deg)\n}\n.control-container-feature-group-collapsible-active, .control-container-feature-group-collapsible:hover {\n  background-color: rgba(100, 133, 172, 1);\n}\n/* ************************************************************************** */\n/* ******************** Mode Controls *************************************** */\n/* ************************************************************************** */\n\n.mode-control-container {\n  position: absolute;\n  bottom: 50px;\n  right: 4px;\n  z-index: 1000;\n}\n\n.mode-control-items {\n  position: relative;\n  background: #233845;\n  padding-left: 10px;\n  padding-right: 10px;\n  text-align:center;\n  border-radius: 10px;\n}\n\n.mode-control-item {\n  display: inline-block;\n  color: white;\n  height: 25px;\n  width: 40px;\n  cursor: pointer;\n}\n\n.mode-control-item.select {\n  background: rgb(50, 80, 99);\n}\n\n/* ************************************************************************** */\n/* ******************** Legend  ********************************************* */\n/* ************************************************************************** */\n\n.map-legend-container {\n  position: absolute;\n  bottom: 20px;\n  right: 8px;\n  z-index: 1000;\n  color: #233845;\n  font-size: 12px;\n  font-weight: 700;\n  width: 310px;\n}\n\n.map-legend-items {\n  background: #233845;\n  padding-right: 10px;\n  text-align: center;\n  border-radius: 10px;\n  display: flex\n}\n\n.map-legend-label {\n  width: 50px;\n  color: #fff;\n}\n\n.map-legend-item {\n  width: 50px\n}\n\n/* ************************************************************************** */\n/* ******************** Weather Map Legend  ********************************* */\n/* ************************************************************************** */\n\n.weather-map-legend-container {\n  position: absolute;\n  bottom: 45px;\n  right: 8px;\n  z-index: 1000;\n  color: #233845;\n  font-size: 12px;\n  font-weight: 700;\n  width: 310px;\n}\n\n.weather-map-legend-items {\n  background: #233845;\n  padding-right: 10px;\n  text-align: center;\n  border-radius: 10px;\n  display: flex;\n  width: 310px;\n}\n\n.weather-map-legend-label {\n  width: 50px;\n  color: #fff;\n}\n\n.weather-map-legend-item-container {\n  display: flex;\n  width: 260px;\n}\n\n.weather-map-legend-item {\n  flex: 0 100%;\n  color: white;\n}\n\n/* ************************************************************************** */\n/* ******************** Animation Controls  ********************************* */\n/* ************************************************************************** */\n\n.animation-controls-container {\n  position: absolute;\n  top: calc(100% - 60px);\n  left: 8px;\n  z-index: 1000;\n  width: calc(100% - 350px);\n  transition: .4s top cubic-bezier(0.0,0.0,0.2,1);\n}\n\n.panel-open .animation-controls-container {\n  top: calc(62% - 60px);\n}\n\n.animation-controls-play {\n  position: relative;\n  width: 36px;\n  height: 36px;\n  font-size: 10px;;\n  color: white;\n  background-color: #233845;\n  cursor: pointer;\n  border-radius: 50%;\n  transition: background-color 3s ease-in-out;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  user-select: none;\n}\n\n/* Should grow */\n.animation-controls-bar {\n  position: absolute;\n  left: 41px;\n  bottom: 14px;\n  width: calc(100% - 40px);\n  height: 8px;\n  background-color: #233845;\n  border-radius: 10px;\n  cursor: pointer;\n}\n\n.animation-controls-bar-played {\n  position: absolute;\n  background-color: rgb(70, 102, 138);\n  height: 100%;\n  width: 25%;\n  transition-duration: 0.2s;\n  border-top-left-radius: 10px;\n  border-bottom-left-radius: 10px;\n}\n\n.animation-controls-labels {\n  position: absolute;\n  left: 42px;\n  bottom: 0;\n  display: flex;\n  width: calc(100% - 40px);\n  align-items: center;\n  line-height: 1;\n  text-shadow: 0px 0px 3px black;\n}\n\n.animation-controls-label {\n  border-right: 1px solid #6f7a81;\n  color: white;\n  font-weight: bold;\n  flex: 1;\n  font-size: 12px;\n  text-align: center;\n  line-height: 1;\n  height: 12px;\n}\n\n.animation-controls-label:last-child {\n  border-right: none\n}\n\n.animation-controls-current-position {\n  position: absolute;\n  bottom: 10px;\n  right: -10px;\n  margin-left: -10px;\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  border-top: 10px solid rgb(70, 102, 138);\n  transition-duration: 0.2s;\n  cursor: grab;\n}\n\n.animation-controls-current-position-panel {\n  position: absolute;\n  border-radius: 10px;\n  padding-left: 10px;\n  padding-top: 2px;\n  padding-right: 10px;\n  padding-bottom: 2px;\n  bottom: 8px;\n  height: 24px;\n  width: 180px;\n  margin-left: -50px;\n  color: white;\n  background-color: rgb(70, 102, 138);\n  font-size: 12px;\n  transition-duration: 0.2s;\n  cursor: grab;\n  user-select: none;\n  text-align: center;\n}\n\n/* ************************************************************************** */\n/* ******************** Hazard Visualizer  ********************************** */\n/* ************************************************************************** */\n\n.rd-hazard-visualizer {\n  display: flex;\n  height: calc(100vh - 37px);\n  border-top: 1px solid var(--grey3)\n}\n\n.rd-hazard-visualizer__title {\n  padding: 1.5rem 1.5rem 0 1.5rem\n}\n\n.rd-hazard-visualizer__header {\n  font-size: 16px;\n  border-bottom: 1px solid #ddd;\n  color: #598987;\n  padding: .25rem 1rem;\n  font-weight: 700;\n}\n\n.rd-hazard-visualizer__region-navigation {\n  flex-shrink: 0;\n  width: 175px;\n  border-right: 1px solid var(--grey3);\n}\n\n.rd-hazard-visualizer__chart-container {\n  display: flex;\n  width: 100%;\n  height: calc(100vh - 55px);\n  background-color: white;\n  margin: auto;\n  text-align: center;\n}\n\n.rd-hazard-visualizer__chart-component {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n\n.rd-hazard-visualizer__line-chart-container {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n\n.rd-hazard-visualizer__chart-component span {\n  font-size: 1.2rem;\n}\n\n.rd-hazard-visualizer__hazard-navigation {\n  border-left: 1px solid var(--grey3);\n  flex-shrink: 0;\n  width: 175px;\n}\n\n.rd-hazard-visualizer__parameter-tab {\n  position: relative;\n  bottom: 0px;\n}\n\n.rd-hazard-visualizer__column {\n  display: flex;\n  flex-direction: column;\n  flex-basis: 100%;\n  flex: 1;\n  width: 100%;\n}\n\n.rd-hazard-visualizer__data-header {\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1px solid #ddd;\n  cursor: pointer;\n  user-select: none;\n  padding: .5rem 1rem;\n}\n\n.rd-hazard-visualizer__data-header > * + * {\n  margin-left: .5rem\n}\n\n.rd-hazard-visualizer__data-header.open {\n  background-color: #598987;\n  color: white;\n}\n\n.rd-hazard-visualizer__data-row {\n  border-bottom: 1px solid #ddd;\n  user-select: none;\n  cursor: pointer;\n  padding: .5rem 1rem\n}\n\n.rd-hazard-visualizer__data-row.open {\n  background-color: #2dbdb6;\n  color: white;\n}\n\n.rd-hazard-visualizer__row {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  width: 100%;\n}\n\n.rd-hazard-visualizer__no-chart {\n  margin: auto;\n  width: 320px;\n  padding: 2rem;\n  background-color: var(--wood-teal-light);\n  text-align: center;\n  position: relative;\n  top: 3rem;\n}\n/* hacky override - need to speak to Adam about leaflet options */\n.leaflet-top .leaflet-control {\n  margin-top: 53px;\n}\n\n\n.leaflet-pane > svg path.leaflet-interactive:hover {\n  fill: rgba(255,255,255,0.3)\n}\n\n.line-chart-d3-cls {\n  font-family: \"Avenir\", Helvetica, Arial, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-align: center;\n  color: #2c3e50;\n  margin-top: 25px;\n  background: white;\n}\n\n/* ************************************************************************** */\n/* ******************** Loading spinner ************************************* */\n/* ************************************************************************** */\n\n.loading-spinner {\n  text-align: center;\n  height: 107px;\n  width: 320px;\n  margin: auto;\n  position: relative;\n  top: 65px;\n  font-weight: 700;\n}\n\n.loading-spinner__text {\n  margin-bottom: 2rem;\n}\n\n/* overrides the styled from the vue component */\n.loading-spinner .spinner {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.cube1[data-v-12edc234],\n.cube2[data-v-12edc234] {\n  background-color: var(--wood-teal);\n}\n\n/* ************************************************************************** */\n/* ******************** Utility classes ************************************* */\n/* ************************************************************************** */\n\n.flex-row {\n  display: flex;\n  align-items: center;\n}\n\n.flex-row--end {\n  display: flex;\n  align-items: flex-end;\n}\n\n.flex-row > * + * {\n  margin-left: .5rem\n}\n\n.u-float-right {\n  float: right\n}\n\n/* ************************************************************************** */\n/* ******************** Site Panel ****************************************** */\n/* ************************************************************************** */\n\n.site-panel {\n  position: absolute;\n  margin-top: 20px;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  max-width: 100%;\n  width: fit-content;\n  max-height: 90vh;\n  z-index: 1000;\n  transition: .4s top cubic-bezier(0.0,0.0,0.2,1);\n  display: flex;\n  flex-shrink: 2;\n}\n\n\n.site-panel__toggle {\n  cursor: pointer;\n  background-color: #fff;\n  width: 70px;\n  height: 20px;\n  position: absolute;\n  top: -19px;\n  left: calc(50% - 35px);\n  border-top: 1px solid var(--grey2);\n  border-left: 1px solid var(--grey2);\n  border-right: 1px solid var(--grey2);\n  z-index: -100;\n  box-shadow: 0 1px 5px rgba(0,0,0,0.65);\n  display: flex;\n  padding: 3px .5rem 0 .5rem;\n  justify-content: space-between;\n}\n\n.site-panel__icon {\n  fill: var(--wood-grey);\n  color: var(--wood-grey);\n}\n\n.site-panel__icon.active {\n  fill: var(--wood-teal);\n  color: var(--wood-teal);\n}\n\n.panel-open .icon-rotate {\n  transform: rotate(180deg);\n  top: 0\n}\n\n.site-panel__toggle::before {\n  content: '';\n  display: block;\n  position: absolute;\n  bottom: -8px;\n  left: -5px;\n  height: 8px;\n  background-color: #fff;\n  right: -5px;\n}\n\n.site-panel__content {\n  background-color: #fff;\n  border-top: 1px solid var(--grey2);\n  width: fit-content;\n  max-width: 100vw;\n  box-shadow: 0 1px 5px rgba(0,0,0,0.65);\n  padding: 0.5rem;\n  overflow-y: auto;\n}\n\nbody::-webkit-scrollbar-track,\n.site-panel__content::-webkit-scrollbar-track,\n.timelines__scrollpane::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);\n  border-radius: 6px;\n  background-color: #F5F5F5;\n}\n\nbody::-webkit-scrollbar,\n.site-panel__content::-webkit-scrollbar,\n.timelines__scrollpane::-webkit-scrollbar {\n  width: 6px;\n  background-color: #F5F5F5;\n}\n\nbody::-webkit-scrollbar-thumb,\n.site-panel__content::-webkit-scrollbar-thumb,\n.timelines__scrollpane::-webkit-scrollbar-thumb {\n  background-color: var(--grey3);\n}\n\n/* timeline content when it is placed in the sidepanlel*/\n.site-panel .timelines__scrollpane {\n  overflow-x: auto;\n  width: calc(100vw - 2rem - 178px);\n}\n\n.site-panel .rd-table__risk-info {\n  height: 34px;\n  padding-right: 6px;\n}\n\n.site-panel .rd-table__risk-cell {\n  height: 34px;\n  border-radius: 17px;\n}\n\n.site-panel .rd-table__risk-number {\n  line-height: 24px;\n  font-size: 1rem;\n  width: 24px;\n  height: 24px;\n}\n\n.site-panel .timelines__timeline-row {\n  height: 34px\n}\n\n.site-panel .timeline__unit {\n  height: 21px;\n}\n\n.site-panel .timelines__hazard-cell {\n  margin-bottom: 0;\n  padding-top: 0\n}\n\n.site-panel .rd-table {\n  font-size: .8rem;\n}\n\n/* Overwrite some vue-form-wizard styles */\n.vue-form-wizard .wizard-nav-pills > li > a {\n  color: rgb(48, 42, 42)!important;\n}\n\n.stepTitle{\n  color: rgb(48, 42, 42)!important;\n}\n\n.swal-text {\n color: rgba(0,0,0,.84)!important;\n}\n\n.tabcontent {\n  border-bottom: none!important;\n}\n.tabs {\n  min-height: 0px!important;\n}\n.vue-form-wizard {\n  padding-bottom: 20px;\n  background: rgb(211 39 55 / 5%)!important;\n}\n.vue-form-wizard label[for]{\n  cursor:pointer;\n}\n.swal-button {\n  background-color: var(--wood-teal)!important;\n}\n.swal-button--danger {\n  background-color: #e64942!important;\n}\n.swal-button--cancel {\n  color: #555;\n  background-color: #efefef!important;\n}\n.left-15 {\n  padding-left: 15%\n}\n.wizard-header {\n  display: none!important;\n}\n.row-clean {\n  display: flex;\n  flex-direction: row;\n}\n.wizard-tab-content {\n  padding: 10px 20px 10px!important;\n}\n.wizard-parameter-tab {\n  display: flex;\n  justify-content: flex-start;\n}\n.wizard-parameter-item {\n  padding:8px;\n  width:25%;\n}\n.wizard-parameter-add-container {\n  padding-top:24px;\n}\n.wizard-parameter-container {\n  display:flex;\n  flex-direction: column;\n}\n.wizard-parameter-content {\n  display: flex;\n  flex-direction: row;\n}\n.wizard-parameter-select {\n  float: left;\n}\n.wizard-parameter-remove-btn {\n  vertical-align: middle;\n  display:inline-block;\n  margin: 6px\n}\n.wizard-parameter-table, .wizard-review-detail-table {\n  border-collapse: collapse;\n  box-shadow: #CCC 2px 2px 5px;\n}\n.wizard-parameter-table tr:last-child td, .wizard-review-detail-table tr:last-child td {\n  border:none;\n}\n.wizard-parameter-table thead {\n  background-color: var(--wood-teal);\n  color:#fff;\n}\n.wizard-parameter-table thead th {\n  padding:8px;\n}\n.wizard-parameter-table tr td {\n  padding:8px;\n  text-align: center;\n}\n.wizard-parameter-table tr td:first-child {\n  text-align: right;\n}\n.wizard-parameter-table tbody td {\n  border-bottom: 1px solid var(--grey4);\n}\n.wizard-review-detail-table tr td {\n  padding:8px;\n  text-align: center;\n  border-bottom: 1px solid var(--grey4);\n}\n.wizard-review-detail-table tr td:first-child {\n  background-color: var(--wood-teal);\n  color: #fff;\n  text-align: right;\n  border-bottom: none;\n}\n .wizard-review-container {\n   display:flex;\n   flex-direction: row;\n   justify-content: space-evenly;\n   padding: 32px;\n }\n.wizard-hr {\n  border:none;\n  border-bottom: 1px solid var(--grey4);\n}\n.wg-form-control {\n  background-color:white!important;\n}\n.pull-left {\n  display: inline-block;\n}\n.left-80 {\n  padding-left: 80%;\n}\n.left-65 {\n  padding-left: 65%;\n}\n.left-15 {\n  padding-left: 15%;\n}\n.left-45 {\n  padding-left: 45%;\n}\n.w-25 {\n  width: 25%;\n}\n.short-text {\n  white-space: nowrap!important;\n  text-overflow: ellipsis!important;\n  overflow: hidden!important;\n  font-size:14px!important;\n  font-weight: bold!important;;\n}\n/******************************************************/\n/******************* Feature Panel ********************/\n/******************************************************/\n.wg-feature-table-container{\n  display:flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n\n}\n.wg-feature-table-container-item{\n  text-align: center;\n}\n.wg-feature-table-inner-container{\n  display: flex;\n  flex-direction: row;\n\n}\n.wg-flex-container{\n  display: flex;\n  flex-direction: column;\n  width: fit-content;\n  max-width: 50vw;\n  height:100%;\n}\n.wg-feature-table-header{\n  overflow: hidden;\n  background-color: var(--wood-teal);\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  color:white;\n}\n.wg-feature-table {\n  border-collapse: collapse;\n}\n.wg-feature-table td {\n  padding: 5px 12px;\n  min-width: 100px;\n  max-width: 50%;\n  text-align: left;\n}\n.wg-feature-table > tbody td:first-child {\n  text-align: left;\n  white-space: nowrap;\n  background-color: var(--wood-grey);\n  color:white;\n\n}\n.wg-flex-header{\n  text-align: center;\n}\n.leaflet-touch .leaflet-control-layers-toggle {\n  width: 34px!important;\n  height: 34px!important;\n}\n.slider-input {\n  width: 50px!important;\n  padding: 5px!important;\n}\n.slider-input-container{\n  width: 350px!important;\n  padding: 5px!important;\n}\n.slider-input-container label {\n  display: block;\n  margin-bottom: 2px;\n  font-size: 12px;\n}\n.wg-range-slider {\n  width: 100%;\n  cursor: pointer;\n  accent-color: #3498db;\n}\n.slider-container-row {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center\n}\n.warning {\n  border: solid 0.1px #d04435;\n  text-align: center;\n  color: #d04435;\n  padding: 10px;\n  width: 100%;\n}\n\n.feature-navigators {\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n}\n\n.feature-navigate-button {\n  background-color: #f1f1f1;\n  color: black;\n  text-decoration: none;\n  border-radius: 50%;\n  display: inline-block;\n  margin-right: 5px;\n  margin-left: 5px;\n  padding: 8px 16px;\n}\n\n.feature-navigate-button:hover {\n  background-color: #ddd;\n  color: black;\n}\n\n/******************************************************/\n/******************* Cookie Banner ********************/\n/******************************************************/\n\n.cookieBanner {\n  position: fixed;\n  bottom: 40px;\n  box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);\n  background-color: var(--wood-grey);\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  padding: 5px 12px;\n  left: 25%;\n  right: 25%;\n  width: 50%;\n  z-index: 1000;\n}\n.cookieBannerContent {\n  flex-direction: column;\n  display: flex;\n  flex-grow: 1;\n  flex-basis: 600px;\n  padding: 10px;\n}\n.cookieBannerHeader {\n  color: #ffffff;\n}\n.cookieBannerButtons {\n  flex-direction: row;\n  display: flex;\n  margin: 16px 8px 8px;\n}\n.cookieBannerButton {\n  padding: 0.5rem 1rem;\n  margin: 5px;\n  color: #ffffff;\n  border: 1px solid #ffffff;\n  font-size: medium;\n  background-color: transparent;\n  border-radius: 0;\n}\n.cookieBannerButton:hover {\n  color: #ffffff;\n  background-color: var(--wood-teal);\n}\n\n/******************************************************/\n/******************* Policies Page ********************/\n/******************************************************/\n\n.policiesBody {\n  margin-left: auto;\n  margin-right: auto;\n  width: 100%;\n  margin-top: 3%;\n  margin-bottom: 12%;\n}\n.policiesHeader {\n  display: block;\n  font-weight: bold;\n  margin-left: 1em;\n}\n.policiesHeaderH2 {\n  display: block;\n  font-weight: bold;\n  margin-left: 1.2em;\n}\n.policiesHeaderH3 {\n  display: block;\n  font-weight: bold;\n  margin-left: 1.8em;\n}\n.policiesParagraph {\n  display: block;\n  margin-left: 2em;\n  margin-right: 1.2em;\n  font-size: 1.2em;\n}\n.policiesGroup {\n  margin-top: 50px;\n}\n\n/******************************************************/\n/******************* Profile Page ********************/\n/******************************************************/\n\n\n.profileButton {\n  color: #fff;\n  background-color: #337ab7;\n  border-color: #2e6da4;\n  display: inline-block;\n  margin-bottom: 0;\n  font-weight: 400;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  cursor: pointer;\n  background-image: none;\n  border: 1px solid transparent;\n  padding: 6px 12px;\n  font-size: 14px;\n  line-height: 1.42857143;\n  border-radius: 4px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.profileSettings {\n  margin-top: 15px;\n  margin-left: 15px;\n}\n\n.profileOptionsSelector:hover {\n  background-color:#337ab7\n}\n\n/* start tabs */\n.profileTabs {\n  position: relative;\n  clear: both;\n  margin: 25px 0;\n}\n.profileTab {\n  float: left;\n}\n.profileTabLabel {\n  cursor: pointer;\n  background: #eee;\n  padding: 10px;\n  border: 1px solid #ccc;\n  margin-left: -1px;\n  position: relative;\n  left: 1px;\n}\n.profileTab [type=radio] {\n  display: none;\n}\n.profileTabContent {\n  position: absolute;\n  top: 28px;\n  left: 0;\n  background: white;\n  right: 0;\n  bottom: 0;\n  padding: 20px;\n  border-top: 1px solid #ccc;\n}\n\n[type=radio]:checked ~ label ~ .profileTabContent {\n  z-index: 1;\n}\n\n.validation-label {\n  width: 250px; /* Seriously - this shouldn't be hard-coded */\n  position: relative;\n  background: white;\n  height: 26px;\n  border: 2px solid black;\n  left: -15px;\n  padding-left: 4px;\n  padding-right: 4px;\n  padding-top: 2px;\n  padding-bottom: 2px;\n}\n\n.validation-label-pointer-outer {\n  position: relative;\n  bottom: 36px;\n  left: 15px;\n  width: 0; \n  height: 0; \n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  border-bottom: 10px solid black;\n}\n\n.validation-label-pointer-inner {\n  width: 0; \n  height: 0; \n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  border-bottom: 10px solid white;\n  position: relative;\n  left: -10px;\n  top: 2px;\n}\n\n/******************************************************/\n/******************* Editor Page ********************/\n/******************************************************/\n\n.editor-modal-mask {\n  position: fixed;\n  z-index: 1000;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: table;\n  transition: opacity 0.3s ease;\n}\n\n.editor-modal-wrapper {\n  display: table-cell;\n  vertical-align: middle;\n}\n\n.editor-modal-container {\n  width: fit-content;\n  max-width: 95%;\n  flex-wrap: wrap;\n  margin: 0px auto;\n  padding: 20px 30px;\n  background-color: #fff;\n  border-radius: 2px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);\n  transition: all 0.3s ease;\n  font-family: Helvetica, Arial, sans-serif;\n}\n\n.editor-modal-header h3 {\n  margin-top: 0;\n  color: #42b983;\n}\n\n.editor-modal-body {\n  margin: 20px 0;\n}\n\n.editor-modal-default-button {\n  cursor: pointer;\n  float: right;\n  text-align: center;\n  vertical-align: middle;\n  user-select: none;\n  background-color: transparent;\n  border: 1px solid transparent;\n  font-size: 1rem;\n  line-height: 1.5;\n  border-radius: 27px;\n  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n  color: #fff;\n  border-radius: 27px;\n  font-weight: 700;\n  padding: .5rem 1.7rem;\n}\n\n.editor-modal-default-button:hover {\n    opacity: .7;\n    color: #fff\n}\n\n.editor-modal-default-button--grey {\n    background-color: var(--wood-grey);\n}\n\n.editor-modal-default-button--teal {\n    background-color: var(--wood-teal);\n}\n\n.editor-modal-enter {\n  opacity: 0;\n}\n\n.editor-modal-leave-active {\n  opacity: 0;\n}\n\n.editor-modal-enter .modal-container,\n.editor-modal-leave-active .modal-container {\n  -webkit-transform: scale(1.1);\n  transform: scale(1.1);\n}\n\n.editorTabs {\n  position: relative;\n  clear: both;\n  margin: 25px 0;\n}\n.editorTab {\n  float: left;\n}\n.editorTabLabel {\n  cursor: pointer;\n  background: #eee;\n  padding: 10px;\n  border: 1px solid #ccc;\n  margin-left: -1px;\n  position: relative;\n  left: 1px;\n}\n.editorTab [type=radio] {\n  display: none;\n}\n.editorTabContent {\n  position: absolute;\n  top: 28px;\n  left: 0;\n  background: white;\n  right: 0;\n  bottom: 0;\n  padding: 20px;\n  border-top: 1px solid #ccc;\n}\n[type=radio]:checked ~ label {\n  background: white;\n  border-bottom: 1px solid white;\n  z-index: 1;\n}\n[type=radio]:checked ~ label ~ .editorTabContent {\n  z-index: 1;\n}\n\n\n/******************************************************/\n/******************* Region Panel ********************/\n/******************************************************/\n\n.rd-table__location-icon__active {\n  color: blue;\n}\n.rd-table__filter-header {\n  width: 50px;\n  text-align: center\n}\n.rd-table__filter-cell {\n  width: 50px;\n  vertical-align: middle;\n  font-weight: 700\n}\n.rd-table__filter-text {\n  display: flex;\n  justify-content: space-between;\n}\n\n\n/******************************************************/\n/******************* User Menu Buttons ********************/\n/******************************************************/\n\n\n.user-dropbtn {\n  color: white;\n  padding: 2px 4px;\n  font-size: 16px;\n  border: none;\n  z-index: 10000;\n}\n\n/* The container <div> - needed to position the dropdown content */\n.user-dropdown {\n  position: relative;\n  display: inline-block;\n}\n\n/* Dropdown Content (Hidden by Default) */\n.user-dropdown-content {\n  display: none;\n  position: absolute;\n  background-color: #f1f1f1;\n  min-width: 80px;\n  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);\n  z-index: 2000;\n  right: 0px;\n  top: 20px;\n}\n\n/* Links inside the dropdown */\n.user-dropdown-content a {\n  color: black;\n  padding: 12px 16px;\n  text-decoration: none;\n  display: block;\n}\n\n/* Change color of dropdown links on hover */\n.user-dropdown-content a:hover {background-color: #ddd;}\n\n/* Show the dropdown menu on hover */\n.user-dropdown:hover .user-dropdown-content {display: block;}\n\n/* Change the background color of the dropdown button when the dropdown content is shown */\n.user-dropdown:hover .user-dropbtn {}\n\n\n/******************************************************/\n/******************* Parameter Config ********************/\n/******************************************************/\n\n\npath.line {\n  fill: none;\n  stroke: #ecbc3a;\n  stroke-width: 3px;\n}\n\n/*Some fancy animation to draw chart*/\nsvg .lineChart > path {\n  background-color: #fff;\n  stroke: #000;\n  stroke-width: 3;\n  stroke-dasharray: 4813.713;\n  stroke-dashoffset: 4813.713;\n\n  -webkit-animation-duration: 0s;\n  animation-duration: 0s;\n  -webkit-animation-fill-mode: forwards;\n  animation-fill-mode: forwards;\n  -webkit-animation-iteration-count: 1;\n  animation-iteration-count: 1;\n  -webkit-animation-timing-function: linear;\n  animation-timing-function: linear;\n  -webkit-animation-name: draw;\n  animation-name: draw;\n}\n\n@-webkit-keyframes draw {\n  100% { stroke-dashoffset: 0; }\n}\n@keyframes draw {\n  100% {stroke-dashoffset: 0;}\n}\n\n/******************************************************/\n/******************* D3 Chart ********************/\n/******************************************************/\n\n.chart-tooltip {\n  position: absolute;\n  z-index: 10;\n  visibility: hidden;\n  background-color: rgba(255, 255, 255, 0.8);\n  text-align: center;\n  padding: 4px;\n  border-radius: 4px;\n  color: black;\n  font-family: \"Helvetica Neue\",Helvetica,Arial,sans-serif;\n  font-size: 14px;\n  font-style: normal;\n}\n\n.chart-data-root {\n  display: flex;\n}\n\n.chart-data-root > .chart-data-line-chart {\n  flex-flow: row wrap\n}\n\n.chart-data-line-chart {\n  font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  position: relative;\n  border-bottom: 2px solid black;\n}\n\n.chart-data-line-chart path.domain {\n  stroke: black\n}\n\n.chart-data-line-chart .invalid-options {\n  border: 1px solid red;\n  padding: 1rem;\n}\n\n.chart-data-line-chart .overlay {\n  fill: none;\n  pointer-events: all;\n}\n\n.chart-data-line-chart .line {\n  stroke-width: 2;\n  fill: none;\n}\n\n.chart-data-line-chart .tick .line {\n  stroke: black;\n}\n\n.chart-data-line-chart .axis .tick text {\n  font-size: 14px;\n  stroke: black;\n  stroke-width: 0.2px;\n}\n\n.chart-data-line-chart .line-graph-label {\n  font-size: 14px;\n  fill: black;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
